/* العربية — Arabic */
const ar = {
  nav: {
    home: 'الرئيسية',
    imageConverter: 'محول الصور',
    imageCompressor: 'ضاغط الصور',
    otherTools: 'أدوات أخرى',
    resizeImage: 'تغيير حجم الصورة',
    cropImage: 'قص الصورة',
    photoEditor: 'محرر الصور',
    removeBackground: 'إزالة الخلفية',
    watermarkImage: 'علامة مائية',
    qrCodeGenerator: 'مولد رمز QR',
    qrCodeScanner: 'ماسح رمز QR',
    aboutUs: 'من نحن',
    faceBlur: 'تمويه الوجه',
  },
  hero: {
    heading: 'كل أداة صور تحتاجها',
    subheading: 'أدوات مجانية عبر الإنترنت لتحويل وضغط وتغيير حجم وقص وتحرير وتحويل صورك. كل المعالجة تتم في متصفحك — سريعة وخاصة وآمنة.',
  },
  tools: {
    compressImage: { title: 'ضغط الصورة', desc: 'ضغط JPG و PNG و SVG و GIF مع توفير المساحة والحفاظ على الجودة.' },
    resizeImage: { title: 'تغيير حجم الصورة', desc: 'حدد أبعادك بالنسبة المئوية أو البكسل وغير حجم صور JPG و PNG و SVG و GIF.' },
    cropImage: { title: 'قص الصورة', desc: 'قص JPG أو PNG أو GIF بسهولة.' },
    convertToJpg: { title: 'تحويل إلى JPG', desc: 'حول صور PNG و GIF و SVG و WEBP إلى JPG دفعة واحدة.' },
    convertFromJpg: { title: 'تحويل من JPG', desc: 'حول صور JPG إلى PNG و GIF.' },
    qrCodeGenerator: { title: 'مولد رمز QR', desc: 'أنشئ رموز QR مخصصة للروابط والنصوص وWiFi وجهات الاتصال.' },
    qrCodeScanner: { title: 'ماسح رمز QR', desc: 'امسح رموز QR فورياً باستخدام كاميرتك أو بتحميل صورة.' },
    blurFace: { title: 'تمويه الوجه', desc: 'كشف وتمويه الوجوه تلقائياً في صورك للخصوصية.' },
    removeBackground: { title: 'إزالة الخلفية', desc: 'أزل خلفيات الصور بسرعة وبدقة عالية.' },
    watermarkImage: { title: 'علامة مائية', desc: 'أضف صورة أو نصاً على صورك في ثوانٍ.' },
  },
  whyChoose: {
    label: 'لماذا تختارنا',
    heading: 'الطريقة الأذكى لتحرير الصور',
    subheading: 'موثوق به من آلاف المبدعين والمصممين والمطورين حول العالم.',
    reasons: {
      fast: { title: 'سريع كالبرق', desc: 'كل المعالجة تتم مباشرة في متصفحك. لا تحميل ملفات إلى خوادم خارجية.' },
      private: { title: 'خاص وآمن 100%', desc: 'ملفاتك لا تغادر جهازك أبداً. لا نقوم بتخزين أو مشاركة أو الوصول إلى صورك.' },
      noLimits: { title: 'بلا حدود، بلا تسجيل', desc: 'استخدم كل أداة كما تشاء — مجاناً تماماً.' },
      quality: { title: 'جودة احترافية', desc: 'خوارزمياتنا تقدم نتائج بجودة احترافية.' },
      batch: { title: 'معالجة دفعية', desc: 'تعامل مع ملفات متعددة في وقت واحد.' },
      everywhere: { title: 'يعمل في كل مكان', desc: 'تصميم متجاوب يعمل على الحاسوب والجهاز اللوحي والجوال.' },
    },
    stats: {
      imagesProcessed: 'صور تمت معالجتها',
      countriesServed: 'دول نخدمها',
      uptime: 'وقت التشغيل',
      freeTools: 'أدوات مجانية',
    },
  },
  footer: {
    tagline: 'أدوات صور مجانية عبر الإنترنت — حول واضغط وغير حجم واقص وحرر صورك في ثوانٍ. بدون تسجيل.',
    imageTools: 'أدوات الصور',
    moreTools: 'المزيد من الأدوات',
    company: 'الشركة',
    contact: 'اتصل بنا',
    allRightsReserved: 'جميع الحقوق محفوظة.',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
  },
  faq: {
    badge: 'الأسئلة',
    heading: 'الأسئلة الشائعة',
    subheading: 'إجابات سريعة على الأسئلة الشائعة حول هذه الأداة.',
    stillHaveQuestions: 'لا زلت لديك أسئلة؟ نحن هنا للمساعدة!',
    reachOut: 'تواصل مع فريقنا',
    questionHeader: 'سؤال',
  },

  contactForm: {
    badge: 'تواصل معنا',
    title: 'اتصل بنا',
    subtitle: 'يسعدنا سماع رأيك. أرسل لنا رسالة!',
    nameLabel: 'الاسم',
    namePlaceholder: 'اسمك الكامل',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'you@email.com',
    subjectLabel: 'الموضوع',
    subjectPlaceholder: 'عم ماذا يتحدث هذا؟',
    messageLabel: 'الرسالة',
    messagePlaceholder: 'اكتب رسالتك هنا…',
    errName: 'الاسم مطلوب',
    errEmail: 'البريد الإلكتروني مطلوب',
    errEmailInvalid: 'أدخل بريدًا إلكترونيًا صحيحًا',
    errSubject: 'الموضوع مطلوب',
    errMessage: 'الرسالة مطلوبة',
    sending: 'جارٍ الإرسال…',
    send: 'إرسال الرسالة',
    successTitle: 'تم إرسال الرسالة!',
    successMsg: 'شكرًا على تواصلك. سنرد عليك قريبًا.',
    sendAnother: 'إرسال رسالة أخرى',
    sendError: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  },

  about: {
    label: 'من نحن',
    heading: 'صُنع للمبدعين، بواسطة المبدعين',
    subheading: 'نؤمن بأن أدوات الصور القوية يجب أن تكون مجانية وسريعة ومتاحة للجميع.',
    missionTitle: 'مهمتنا',
    missionText: 'تم إنشاء photremium.com بهدف بسيط: تقديم تجربة تحرير صور أكثر سهولة وسرعة وخصوصية على الويب.',
    privacyTitle: 'الخصوصية أولاً',
    privacyText: 'لا نقوم أبداً بتحميل أو تخزين أو معالجة صورك على خوادم بعيدة.',
    techTitle: 'تقنية حديثة',
    techText: 'مبني بأحدث تقنيات الويب بما في ذلك WebAssembly و Canvas API و React الحديث.',
    communityTitle: 'مدفوع بالمجتمع',
    communityText: 'كل ميزة نبنيها مستوحاة من ملاحظات المستخدمين الحقيقية.',
    globalTitle: 'انتشار عالمي',
    globalText: 'يستخدمه المبدعون في أكثر من 120 دولة.',
  },
  seo: {
    homeTitle: 'photremium.com — محول وضاغط ومحرر صور مجاني عبر الإنترنت',
    homeDesc: 'حول واضغط وغير حجم واقص وحرر الصور مجاناً عبر الإنترنت.',
    homeKeywords: 'محول صور، ضاغط صور، تغيير حجم صورة، محرر صور',
    aboutTitle: 'عن photremium.com — مهمتنا وقصتنا',
    aboutDesc: 'تعرف على photremium.com، مجموعة أدوات الصور المجانية الموثوقة من الملايين.',
    aboutKeywords: 'عن photremium.com، أدوات صور، محرر صور مجاني',
  },
          privacyPolicyPage: {
    seo: {
      title: 'سياسة الخصوصية — فوتريميوم | لا توجد تحميلات على الخادم، ولا يوجد تخزين للبيانات',
      description: 'تشرح سياسة خصوصية Photremium كيف نحمي خصوصيتك. تتم جميع عمليات معالجة الصور بنسبة 100% في متصفحك — لا يتم تحميل أي ملف إلى أي خادم، ولا يتم جمع أي بيانات شخصية، ولا يوجد تتبع.',
      ogTitle: 'سياسة الخصوصية — فوتريميوم | لا يوجد تحميلات، تخزين صفر',
      ogDescription: 'تبقى ملفاتك على جهازك. يقوم Photremium بمعالجة جميع الصور محليًا في متصفحك دون أي اتصال بالخادم أو تخزين بيانات أو تتبع.',
      twitterTitle: 'سياسة الخصوصية – فوتريميوم',
      twitterDescription: 'أدوات الصور المعتمدة على المتصفح بنسبة 100%. لا تحميلات، لا تخزين، لا تتبع. اقرأ سياسة الخصوصية الكاملة لدينا.',
      schemaName: 'سياسة الخصوصية - فوتريميوم',
      schemaDescription: 'سياسة خصوصية Photremium - لا يوجد تحميلات على الخادم، ولا توجد بيانات مخزنة، ومعالجة الصور في المتصفح بنسبة 100%.'
    },
    hero: {
      badge: 'سياسة الخصوصية',
      titlePrefix: 'خصوصيتك هي ملكنا',
      titleHighlight: 'الأولوية القصوى',
      subPrefix: 'تم بناء موقع photremium.com على مبدأ بسيط —',
      subStrong: 'ملفاتك لا تترك جهازك أبدًا',
      subSuffix: 'تعمل كل أداة صور موجودة على هذا الموقع بالكامل داخل متصفحك. لا توجد تحميلات. لا سحابة. لا يوجد حل وسط.',
      effectiveLabel: 'فعال',
      lastUpdatedLabel: 'آخر تحديث',
      worldwideLabel: 'ينطبق في جميع أنحاء العالم'
    },
    trustCards: [
      {
        title: 'لا توجد تحميلات الخادم',
        desc: 'ملفاتك لا تترك جهازك أبدًا. تتم جميع عمليات المعالجة داخل المتصفح بنسبة 100%.'
      },
      {
        title: 'تخزين البيانات صفر',
        desc: 'نحن لا نقوم بتخزين أي شيء عنك أو صورك أو نشاطك.'
      },
      {
        title: 'لا تتبع',
        desc: 'لا يوجد تتبع سلوكي، ولا بصمات أصابع، ولا ملفات تعريف.'
      },
      {
        title: 'صديقة للائحة العامة لحماية البيانات',
        desc: 'تم تصميمه من الألف إلى الياء لاحترام لوائح الخصوصية العالمية.'
      }
    ],
    contentsTitle: 'محتويات',
    toc: {
      overview: 'ملخص',
      'no-upload': 'لا يوجد معالجة الخادم',
      'data-collect': 'البيانات التي نجمعها',
      cookies: 'ملفات تعريف الارتباط والتخزين',
      'third-party': 'خدمات الطرف الثالث',
      analytics: 'التحليلات',
      children: 'خصوصية الأطفال',
      rights: 'حقوقك',
      security: 'حماية',
      changes: 'تغييرات السياسة',
      contact: 'اتصل بنا'
    },
    sections: {
      overview: {
        title: '1. نظرة عامة',
        subtitle: 'ما تغطيه هذه السياسة',
        p1Prefix: 'تصف سياسة الخصوصية هذه كيف',
        p1Middle: '("نحن" أو "لنا" أو "خاصتنا") نتعامل - أو بشكل أكثر دقة،',
        p1Italic: 'لا يتعامل',
        p1Suffix: 'معلوماتك الشخصية عند استخدام أدوات الصور المجانية عبر الإنترنت على',
        p2: 'على عكس تطبيقات الويب التقليدية التي ترسل الملفات إلى خوادم بعيدة للمعالجة، يستخدم موقع photremium.com واجهات برمجة التطبيقات الحديثة للمتصفح (Canvas API وWebAssembly وWebWorkers) لتنفيذ كل عملية محليًا على جهازك. النتيجة: لا نقل للبيانات، ولا تخزين، ولا مخاطر.',
        calloutLabel: 'ملخص انجليزي عادي:',
        calloutText: 'لا يمكننا رؤية صورك، ولا نريد ذلك، وقد تم تصميم تقنيتنا خصيصًا بحيث لا نتمكن من ذلك أبدًا.'
      },
      noUpload: {
        title: '2. لا توجد معالجة للخادم – على الإطلاق',
        subtitle: 'كيف تعمل أدواتنا فعليًا',
        introPrefix: 'تقوم جميع الأدوات الموجودة على موقع photremium.com - محول الصور، والضاغط، ومغير الحجم، ومزيل الخلفية، وطمس الوجه، والعلامة المائية، والقص، وأدوات رمز الاستجابة السريعة - بمعالجة ملفاتك',
        introStrong: '100% داخل متصفح الويب الخاص بك',
        introSuffix: 'باستخدام JavaScript وWebAssembly من جانب العميل.',
        points: [
          {
            label: 'لا يحدث أي تحميل للملفات على الإطلاق.',
            text: 'عندما تحدد ملفًا، تتم قراءته بواسطة File API في متصفحك وتتم معالجته في الذاكرة — ولا يتم إرساله مطلقًا عبر الشبكة.'
          },
          {
            label: 'لا يوجد خادم يستقبل صورتك.',
            text: 'يخدم CDN الخاص بنا فقط أصول HTML وCSS وJavaScript اللازمة لتشغيل التطبيق، وليس ملفاتك.'
          },
          {
            label: 'لا يوجد تخزين مؤقت.',
            text: 'النتائج التي تمت معالجتها موجودة فقط في ذاكرة المتصفح الخاص بك ويتم إصدارها عند إغلاق الصفحة أو الابتعاد عنها.'
          },
          {
            label: 'يعمل حاليا.',
            text: 'تستمر معظم الأدوات في العمل دون اتصال بالإنترنت بعد التحميل الأولي للصفحة - وهو دليل إضافي على عدم وجود خادم.'
          }
        ],
        callout: 'يمكنك التحقق من ذلك بنفسك: افتح علامة تبويب الشبكة في متصفحك في أدوات المطور، وحدد صورة، وتأكد من عدم نقل أي بيانات ملف إلى أي خادم خارجي.'
      },
      dataCollect: {
        title: '3. البيانات التي نجمعها (ولا نجمعها)',
        subtitle: 'الشفافية الكاملة بشأن ممارسات البيانات',
        headers: {
          type: 'نوع البيانات',
          collected: 'جمعت؟',
          whereWhy: 'أين / لماذا'
        },
        rows: [
          {
            type: 'الصور / الملفات الخاصة بك',
            badge: 'أبداً',
            variant: 'أخضر',
            showX: true,
            whereWhy: 'تمت معالجتها بالكامل في متصفحك — ولم يتم نقلها مطلقًا'
          },
          {
            type: 'الاسم / عنوان البريد الإلكتروني',
            badge: 'أبداً',
            variant: 'أخضر',
            showX: true,
            whereWhy: 'لا يلزم وجود حساب أو تسجيل لاستخدام أي أداة'
          },
          {
            type: 'عنوان IP',
            badge: 'الحد الأدنى',
            variant: 'رمادي',
            showX: false,
            whereWhy: 'يتم الاحتفاظ بسجلات خادم الويب القياسية لمدة <= 30 يومًا، وغير مرتبطة بالهوية'
          },
          {
            type: 'نوع المتصفح/نظام التشغيل',
            badge: 'الحد الأدنى',
            variant: 'رمادي',
            showX: false,
            whereWhy: 'يتم إرسالها بواسطة متصفحك تلقائيًا؛ تستخدم فقط من أجل التوافق'
          },
          {
            type: 'الصفحات التي تمت زيارتها/النقرات',
            badge: 'مجمعة',
            variant: 'أزرق',
            showX: false,
            whereWhy: 'تحليلات مجهولة المصدر فقط (لا يوجد تعريف شخصي)'
          },
          {
            type: 'تفضيل اللغة',
            badge: 'محلي فقط',
            variant: 'أزرق',
            showX: false,
            whereWhy: 'تم الحفظ في localStorage على جهازك - ولم يتم إرساله إلينا مطلقًا'
          },
          {
            type: 'الدفع / البيانات المالية',
            badge: 'أبداً',
            variant: 'أخضر',
            showX: true,
            whereWhy: 'photremium.com مجاني تمامًا ولا يتطلب أي دفعات'
          }
        ]
      },
      cookies: {
        title: '4. ملفات تعريف الارتباط والتخزين المحلي',
        subtitle: 'ما يتم تخزينه على جهازك',
        intro: 'لا يستخدم موقع photremium.com أي ملفات تعريف ارتباط إعلانية، ولا ملفات تعريف ارتباط للتتبع عبر المواقع، ولا ملفات تعريف ارتباط تابعة لجهات خارجية. مساحة تخزين المتصفح الوحيدة التي نستخدمها هي لوظائف الموقع الأساسية.',
        points: [
          {
            label: 'تفضيل اللغة',
            text: 'يتم تخزينها في localStorage حتى يتذكر الموقع لغتك المفضلة بين الزيارات. لم يتم إرسالها إلى خوادمنا أبدًا.'
          },
          {
            label: 'تفضيلات الموضوع / واجهة المستخدم',
            text: 'إذا قمت بتعيين تفضيل العرض، فسيتم حفظه محليًا على جهازك فقط.'
          },
          {
            label: 'لا توجد ملفات تعريف الارتباط للجلسة.',
            text: 'لا يحتوي موقع photremium.com على نظام تسجيل دخول، لذلك لا تتم كتابة ملفات تعريف الارتباط لمعرف الجلسة على الإطلاق.'
          }
        ],
        callout: 'يمكنك مسح كل مساحة التخزين المحلية لموقع photremium.com في أي وقت عبر إعدادات المتصفح الخاص بك (الإعدادات -> الخصوصية -> مسح بيانات التصفح -> البيانات وملفات تعريف الارتباط المخزنة مؤقتًا). إن القيام بذلك ليس له أي تأثير على قدرتك على استخدام الأدوات.'
      },
      thirdParty: {
        title: '5. خدمات الطرف الثالث',
        subtitle: 'الخدمات الخارجية التي نستخدمها ولماذا',
        intro: 'يستخدم موقع photremium.com مجموعة صغيرة من خدمات الجهات الخارجية الموثوقة حصريًا للبنية التحتية والأداء. لا تتلقى أي من هذه الخدمات صورك أو أي معلومات تعريف شخصية.',
        headers: {
          service: 'خدمة',
          purpose: 'غاية',
          dataShared: 'البيانات المشتركة',
          privacyPolicy: 'سياسة الخصوصية'
        },
        rows: [
          {
            service: 'صفحات كلاود فلير',
            purpose: 'استضافة وتسليم CDN لأصول الموقع',
            dataShared: 'عنوان IP، رؤوس HTTP (قياسية)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'الخط رائع',
            purpose: 'خطوط الأيقونات المحملة من CDN',
            dataShared: 'عنوان IP (طلب CSS فقط)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'خطوط جوجل',
            purpose: 'تحميل المحرف (إن أمكن)',
            dataShared: 'عنوان IP (طلب الخط فقط)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'نحن لا نشارك بياناتك مع المعلنين أو وسطاء البيانات أو أي طرف ثالث آخر بخلاف موفري البنية التحتية المذكورين أعلاه.'
      },
      analytics: {
        title: '6. التحليلات',
        subtitle: 'بيانات الاستخدام الإجمالية والمحترمة للخصوصية',
        introPrefix: 'لفهم الأدوات الشائعة وكيفية تحسين الموقع، قد نقوم بجمعها',
        introStrong: 'مجمعة، مجهولة المصدر',
        introSuffix: 'إحصائيات الاستخدام مثل:',
        points: [
          'عدد مشاهدات الصفحة لكل أداة (لا يوجد تعريف للمستخدم)',
          'مصدر الإحالة (مثل بحث Google، الرابط المباشر) - لا توجد بيانات شخصية',
          'البيانات الجغرافية على مستوى الدولة (وليس المدينة أو الموقع الدقيق)',
          'نوع المتصفح/الجهاز لتحليل التوافق'
        ],
        calloutLabel: 'لا توجد بيانات مرتبطة بك شخصيا.',
        calloutText: 'نحن لا نستخدم Google Analytics أو Meta Pixel. أي تحليلات نستخدمها هي أدوات الخصوصية أولاً (على سبيل المثال، معقولة أو ما شابه ذلك).'
      },
      children: {
        title: '7. خصوصية الأطفال',
        subtitle: 'COPPA والامتثال لسلامة الأطفال',
        p1: 'لا يقوم موقع photremium.com بجمع أي معلومات شخصية من الأطفال الذين تقل أعمارهم عن 13 عامًا (أو 16 عامًا في الاتحاد الأوروبي بموجب اللائحة العامة لحماية البيانات). نظرًا لأننا لا نجمع أي بيانات شخصية من أي مستخدم، فلا يوجد شيء خاص يمكن القيام به للمستخدمين الأصغر سنًا - فالموقع آمن للجميع بنفس القدر.',
        p2Prefix: 'إذا كنت تعتقد أن أحد الأطفال قد أرسل بطريقة أو بأخرى معلومات شخصية من خلال نموذج الاتصال الخاص بنا، فيرجى الاتصال بنا على الفور على',
        p2Suffix: 'وسوف نقوم بحذفه على الفور.'
      },
      rights: {
        title: '8. حقوقك',
        subtitle: 'القانون العام لحماية البيانات (GDPR) وCCPA وحقوق الخصوصية العالمية',
        intro: 'نظرًا لأن موقع photremium.com لا يجمع أي معلومات شخصية، فإن معظم حقوق موضوع البيانات تنطبق بشكل تافه - لا توجد بيانات عنك للوصول إليها أو تصحيحها أو حذفها. ومع ذلك، فإننا نقر ونحترم بشكل كامل الحقوق التالية:',
        points: [
          {
            label: 'الحق في الوصول',
            text: 'يمكنك طلب نسخة من أي بيانات نحتفظ بها عنك. (لا يوجد شيء يتجاوز السجلات مجهولة المصدر.)'
          },
          {
            label: 'الحق في التصحيح',
            text: 'يمكنك طلب تصحيح البيانات الشخصية غير الدقيقة.'
          },
          {
            label: 'الحق في المحو ("الحق في النسيان")',
            text: 'يمكنك طلب حذف أي بيانات شخصية نحتفظ بها (المادة 17 من اللائحة العامة لحماية البيانات، قانون خصوصية المستهلك في كاليفورنيا).'
          },
          {
            label: 'الحق في الاعتراض/الانسحاب',
            text: 'يمكنك إلغاء الاشتراك في أي مجموعة تحليلات مستقبلية باستخدام أداة إلغاء الاشتراك أو حظر الإعلانات على مستوى المتصفح.'
          },
          {
            label: 'الحق في إمكانية نقل البيانات',
            text: 'يتم تنزيل جميع أعمالك مباشرةً على جهازك — دون الحاجة إلى طلب تصدير.'
          }
        ],
        callout: 'تنطبق هذه الحقوق على جميع المستخدمين في جميع أنحاء العالم بغض النظر عن الولاية القضائية - فنحن نطبق أعلى المعايير (GDPR) كخط أساس لدينا.'
      },
      security: {
        title: '9. الأمن',
        subtitle: 'كيف نحمي تجربتك',
        intro: 'البيانات الأكثر أمانًا هي البيانات التي لا يتم جمعها أبدًا. تعني بنية جانب العميل photremium.com أن خرق الخادم لا يمكن أن يكشف ملفاتك لأن ملفاتك لا تكون موجودة على خوادمنا أبدًا. تشمل التدابير الأمنية الإضافية ما يلي:',
        points: [
          {
            label: 'فرض HTTPS',
            text: 'يتم تشفير كل حركة المرور بين متصفحك وشبكة CDN الخاصة بنا عبر TLS 1.2+ مع HSTS.'
          },
          {
            label: 'سياسة أمان المحتوى (CSP)',
            text: 'تمنع الرؤوس الصارمة البرمجة النصية عبر المواقع وحقن البرامج النصية المضمنة.'
          },
          {
            label: 'عمليات تدقيق التبعية المنتظمة',
            text: 'نقوم بتدقيق وتحديث حزم npm بانتظام لتصحيح نقاط الضعف المعروفة.'
          }
        ],
        disclosurePrefix: 'الإفصاح المسؤول',
        disclosureTextPrefix: 'هل وجدت مشكلة أمنية؟ راسلنا عبر البريد الإلكتروني على',
        disclosureTextSuffix: 'وسوف نقوم بالرد خلال 48 ساعة.'
      },
      changes: {
        title: '10. التغييرات في هذه السياسة',
        subtitle: 'كيف نتعامل مع تحديثات السياسة',
        intro: 'يجوز لنا تحديث سياسة الخصوصية هذه من وقت لآخر لتعكس التغييرات في ممارساتنا أو أدواتنا أو متطلباتنا القانونية. عندما نفعل:',
        points: [
          {
            label: '"آخر تحديث"',
            text: 'سيتم تعديل التاريخ الموجود أعلى هذه الصفحة.'
          },
          {
            label: 'التغييرات المادية',
            text: 'سيتم إرسالها عبر إشعار بارز على الصفحة الرئيسية لمدة 30 يومًا على الأقل.'
          },
          {
            label: 'الإصدارات السابقة',
            text: 'سيتم أرشفة هذه السياسة وإتاحتها عند الطلب.'
          }
        ],
        outro: 'استمرار استخدام photremium.com بعد نشر التغييرات يشكل قبولا للسياسة المحدثة. نحن نشجعك على مراجعة هذه الصفحة بشكل دوري.'
      },
      contact: {
        title: '11. طلبات الاتصال والبيانات',
        subtitle: 'تواصل معنا بشأن الخصوصية',
        p1Prefix: 'إذا كانت لديك أية أسئلة أو مخاوف أو طلبات بيانات رسمية تتعلق بسياسة الخصوصية هذه، يرجى الاتصال بنا. ونحن نهدف إلى الرد على جميع الاستفسارات المتعلقة بالخصوصية داخل',
        p1Strong: '5 أيام عمل'
      }
    },
    footer: {
      privacyQuestionsTitle: 'أسئلة الخصوصية؟',
      privacyQuestionsDesc: 'أرسل إلينا أسئلة الخصوصية أو طلبات البيانات أو المخاوف الخاصة بك وسنرد عليها على الفور.',
      versionHistoryTitle: 'تاريخ الإصدار',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: 'جديد!',
    download: 'تحميل',
    downloadAll: 'تحميل الكل',
    upload: 'رفع',
    dragDrop: 'اسحب وأسقط الصور هنا، أو انقر للتصفح',
    remove: 'إزالة',
    reset: 'إعادة تعيين',
    apply: 'تطبيق',
    cancel: 'إلغاء',
    clear: 'مسح',
    close: 'إغلاق',
    save: 'حفظ',
    processing: 'جاري المعالجة...',
    noFiles: 'لم يتم تحديد ملفات',
    selectFiles: 'اختر ملفات',
    or: 'أو',
    browseFiles: 'تصفح الملفات',
    dropHere: 'أسقط الملفات هنا',
    quality: 'الجودة',
    width: 'العرض',
    height: 'الارتفاع',
    format: 'التنسيق',
    compression: 'الضغط',
    preview: 'معاينة',
    original: 'الأصل',
    result: 'النتيجة',
    before: 'قبل',
    after: 'بعد',
    downloadAs: 'تنزيل كـ:',
    zip: 'ملف مضغوط',
    separate: 'كل ملف على حدة',
    chooseFiles: 'اختر الملفات',
    pasteHint: 'يمكنك أيضاً لصق الصور باستخدام',
    startOver: 'البدء من جديد',
    startOverConfirm: 'هل أنت متأكد أنك تريد حذف جميع الصور والبدء من جديد؟',
    addMoreImages: 'إضافة المزيد من الصور',
    addImage: 'إضافة صورة',
    images: 'الصور',
    totalSize: 'الحجم الإجمالي',
    size: 'الحجم',
    type: 'النوع',
    unsavedEdits: 'لديك تعديلات غير محفوظة. هل تريد مغادرة الصفحة؟',
    compareSlider: 'شريط المقارنة',
    toggleToolsPanel: 'تبديل لوحة الأدوات',
    closePanel: 'إغلاق اللوحة',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    fit: 'ملاءمة',
    none: 'لا شيء',
  },

  compressor: {
    seo: {
      uploadTitle: 'ضاغط الصور — اضغط JPG وPNG وSVG وGIF مجاناً | photremium.com',
      uploadDesc: 'اضغط صور JPG وPNG وSVG وGIF عبر الإنترنت مجاناً. قلل حجم الملف حتى 80% مع الحفاظ على الجودة البصرية. لا يلزم تسجيل.',
      uploadKeywords: 'ضاغط صور، ضغط jpg، ضغط png، تقليل حجم الصورة، تحسين الصور',
      workspaceTitle: 'ضغط الصور — ضاغط صور photremium.com',
      workspaceDesc: 'اضبط مستوى الضغط وحمّل صورك المحسّنة.',
      workspaceKeywords: 'ضغط الصور، شريط الضغط، ضغط الصور بالجملة',
    },
    title: 'ضاغط الصور',
    desc: 'اضغط صور JPG وPNG وGIF لتصل إلى 80% أصغر. سريع وخاص — يعمل بالكامل في متصفحك.',
    toCompress: 'للضغط',
    compressionForAll: 'الضغط لجميع الصور',
    summary: 'الملخص',
    originalSize: 'الحجم الأصلي',
    compressed: 'مضغوط',
    saved: 'تم الحفظ',
    compressionLabel: 'الضغط:',
    compressing: 'جارٍ الضغط…',
    compressDownload: 'اضغط وحمّل',
    lowQualityWarning: 'قد يؤدي الضغط العالي إلى تقليل وضوح الصورة بشكل ملحوظ.',
    blog: {
      tocTitle: 'المحتويات',
      title: 'مدونة ضاغط الصور',
      formatsIntro: 'أداتنا تدعم جميع تنسيقات الصور، لذلك يمكنك ضغط أي صورة بسهولة تامة. قائمة كل التنسيقات موضحة أدناه:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. ما هو ضاغط الصور؟',
          paragraphs: [
            'ضاغط الصور هو أداة أو خدمة عبر الإنترنت تقلل حجم ملف الصورة مع الحفاظ على جودتها البصرية. لكن الضغط المفرط قد يسبب انخفاضًا ملحوظًا في الجودة.',
          ],
          listTitle: 'الأنواع:',
          bullets: [
            'الضغط مع فقدان: في هذا النوع يتم تقليل حجم الصورة بحذف جزء من البيانات، وقد تقل الجودة لكن غالبًا لا يكون الفرق واضحًا للعين المجردة.',
            'الضغط دون فقدان: يقلل حجم الملف دون التأثير على الجودة البصرية للصورة.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. لماذا تختار أداتنا؟',
          bullets: [
            'أداة ضغط الصور المعتمدة على الذكاء الاصطناعي تعمل بسلاسة على جميع الأجهزة وتقدم أفضل النتائج الممكنة.',
            'يمكنك ضغط عدة صور (حتى أكثر من 100 صورة) دفعة واحدة بنقرة واحدة فقط.',
            'لا حاجة لرفع صورك إلى خوادمنا، فكل المعالجة تتم محليًا داخل متصفحك.',
            'أداة ضغط الصور لدينا مجانية بالكامل إلى الأبد، ويمكنك مشاركتها مع أصدقائك.',
            'يمكنك اختيار نسبة الضغط حسب رغبتك.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. دليل خطوة بخطوة',
          steps: [
            {
              heading: '1. اختر الصورة/الصور التي تريد ضغطها.',
              bullets: [
                'اسحب وأفلت الصورة/الصور داخل مربع الرفع.',
                'يمكنك أيضًا نسخ الصورة/الصور ولصقها في المربع عبر اختصار لوحة المفاتيح.',
                'كما يمكنك استخدام مستكشف الملفات بالنقر على زر الاختيار.',
              ],
            },
            {
              heading: '2. ثم اختر نسبة الضغط.',
              bullets: [
                'يوفر لك شريط تمرير أفقي طريقة سهلة لتحديد نسبة الضغط. اتبع هذه النطاقات للحصول على نتائج أدق.',
              ],
              table: {
                headers: ['نسبة الضغط', 'النتائج'],
                rows: [
                  ['1%  إلى  40%', 'أفضل جودة'],
                  ['41%  إلى  60%', 'جودة عادية (موصى بها)'],
                  ['61%  إلى  100%', 'جودة منخفضة'],
                ],
              },
            },
            {
              heading: '3. راجع مقدار المساحة التي وفّرتها.',
              paragraphs: [
                'تُعرض جميع مؤشرات المساحة في الوقت الفعلي، بحيث يمكنك معرفة مقدار ما وفّرته من الحجم الإجمالي، ثم ضبط مستوى الضغط حسب حاجتك.',
              ],
            },
            {
              heading: '4. اختر خيار التنزيل من زر التبديل.',
              bullets: [
                'ملف مضغوط: إذا كنت تضغط عدة صور فسيظهر هذا الخيار. باختياره سيتم تجميع كل الصور المضغوطة في ملف واحد مضغوط (موصى به عند عدد كبير من الصور).',
                'كل ملف على حدة: عند اختيار هذا الخيار سيتم تنزيل كل صورة بشكل منفصل وليس في ملف مضغوط واحد (موصى به للأعداد الصغيرة، أقل من 10).',
              ],
            },
            {
              heading: '5. اضغط الصورة ثم نزّلها.',
              paragraphs: [
                'سيقوم هذا الزر بتنزيل كل الصور المضغوطة تلقائيًا حسب خيار التنزيل الذي اخترته.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. فوائد ضاغط الصور.',
          bullets: [
            'تقليل تكلفة التخزين: ضغط الصور يقلل أحجامها بشكل واضح وبالتالي يقلل المساحة المطلوبة.',
            'تحميل أسرع: الصور المضغوطة تُحمّل بسرعة أكبر مما يحسن تجربة المستخدم في الموقع أو التطبيق.',
            'حل حد المرفقات في جي ميل: لأن جي ميل يحد المرفقات حتى 25MB، يساعد الضغط على إرسال عدد أكبر من الملفات.',
            'مشاركة ونقل أسرع: الملفات الكبيرة تستغرق وقتًا أطول في الإرسال والنقل؛ الضغط يوفر الوقت والبيانات.',
            'تحسين العروض التقديمية: الصور غير المضغوطة قد تجعل العرض ثقيلًا وبطيئًا، بينما الصور المضغوطة تقلل الحجم بشكل كبير.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. التنسيقات المدعومة.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'محوّل الصور — تحويل PNG وJPG وWEBP وGIF وSVG مجاناً | photremium.com',
      uploadDesc: 'حوّل الصور بين JPG وPNG وWEBP وGIF وSVG وTIFF وBMP والمزيد. محوّل صور مجاني — سريع وخاص.',
      uploadKeywords: 'محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',
      workspaceKeywords: 'تحويل الصور، محوّل تنسيقات الصور',

      routeKeywords: {

        'png-to-jpg': 'png للتحويل jpg, png to jpg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'jpg-to-png': 'jpg للتحويل png, jpg to png, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'png-to-webp': 'png للتحويل webp, png to webp, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'jpg-to-webp': 'jpg للتحويل webp, jpg to webp, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'webp-to-jpg': 'webp للتحويل jpg, webp to jpg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'webp-to-png': 'webp للتحويل png, webp to png, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'gif-to-jpg': 'gif للتحويل jpg, gif to jpg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'gif-to-png': 'gif للتحويل png, gif to png, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'bmp-to-jpg': 'bmp للتحويل jpg, bmp to jpg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'bmp-to-png': 'bmp للتحويل png, bmp to png, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'svg-to-png': 'svg للتحويل png, svg to png, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'svg-to-jpg': 'svg للتحويل jpg, svg to jpg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'tiff-to-jpg': 'tiff للتحويل jpg, tiff to jpg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'tiff-to-png': 'tiff للتحويل png, tiff to png, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'jpg-to-gif': 'jpg للتحويل gif, jpg to gif, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'png-to-gif': 'png للتحويل gif, png to gif, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'jpg-to-bmp': 'jpg للتحويل bmp, jpg to bmp, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'png-to-bmp': 'png للتحويل bmp, png to bmp, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'webp-to-gif': 'webp للتحويل gif, webp to gif, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'jpg-to-ico': 'jpg للتحويل ico, jpg to ico, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'png-to-ico': 'png للتحويل ico, png to ico, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'jpg-to-svg': 'jpg للتحويل svg, jpg to svg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'png-to-svg': 'png للتحويل svg, png to svg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'webp-to-svg': 'webp للتحويل svg, webp to svg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'gif-to-svg': 'gif للتحويل svg, gif to svg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'bmp-to-svg': 'bmp للتحويل svg, bmp to svg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

        'tiff-to-svg': 'tiff للتحويل svg, tiff to svg, محوّل صور، تحويل png إلى jpg، jpg إلى png، محوّل webp',

      },
    },
    title: 'محوّل الصور',
    desc: 'حوّل الصور بين JPG وPNG وWEBP وGIF وSVG وTIFF وBMP والمزيد. تحويل جماعي لملفات متعددة في آنٍ واحد.',
    toConvert: 'للتحويل',
    convertSettings: 'إعدادات التحويل',
    detected: 'تم الكشف',
    convertTo: 'تحويل إلى',
    converting: 'جارٍ التحويل…',
    convertToFormat: 'تحويل إلى {format}',
    popularConversions: 'التحويلات الشائعة',
    convertingTo: 'تحويل إلى',
    all: 'الكل',
  },

  resizer: {
    seo: {
      uploadTitle: 'تغيير حجم الصور — تغيير حجم JPG وPNG مجاناً | photremium.com',
      uploadDesc: 'غيّر حجم الصور عبر الإنترنت بالبكسل أو النسبة المئوية. مجاناً.',
      uploadKeywords: 'تغيير حجم الصورة، تغيير أبعاد الصورة',
      workspaceTitle: 'تغيير حجم الصور — photremium.com',
      workspaceDesc: 'غيّر حجم الصور عبر الإنترنت مجاناً.',
      workspaceKeywords: 'تغيير حجم الصورة',
    },
    title: 'تغيير حجم الصورة',
    desc: 'حدد أبعادك بالبكسل أو النسبة المئوية أو السنتيمتر أو البوصة وغيّر حجم صورك فوراً.',
    toResize: 'لتغيير الحجم',
    resizeSettings: 'إعدادات تغيير الحجم',
    resizeBy: 'تغيير الحجم بـ:',
    byPixels: 'بالبكسل',
    byPercentage: 'بالنسبة المئوية',
    byCentimeters: 'بالسنتيمتر',
    byInches: 'بالبوصة',
    advanced: 'متقدم',
    lockAspect: 'تأمين نسبة العرض',
    unlockAspect: 'إلغاء تأمين نسبة العرض',
    dontEnlarge: 'لا تكبّر إذا كان الأصل أصغر',
    resizing: 'جارٍ تغيير الحجم…',
    resizeDownload: 'غيّر الحجم وحمّل',
    blog: {
      tocTitle: 'المحتوى',
      title: 'مدونة أداة تغيير حجم الصور',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. لماذا تستخدم أداة تغيير حجم الصور؟',
          paragraphs: [
            'أداة تغيير حجم الصور هي أداة أو برنامج يُستخدم لتغيير أبعاد الصورة. تتيح لك ضبط حجم الصورة المطلوبة عبر تغيير الارتفاع أو العرض أو كليهما. هذه الأداة مفيدة جدًا لمنصات التواصل الاجتماعي التي تفرض قيودًا على أحجام الصور عند الرفع أو النشر.',
          ],
          listTitle: 'على سبيل المثال:',
          bullets: [
            'منشورات إنستغرام: 1080 x 1080px (مربع)',
            'منشور فيسبوك: 1200 x 630px',
            'منشور X (تويتر سابقًا): 1200 x 675px',
            'قصة إنستغرام: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. لماذا تختار أداة تغيير حجم الصور الخاصة بنا؟',
          paragraphs: [
            'أداة تغيير حجم الصور المدعومة بالذكاء الاصطناعي لدينا تجعل عملية تغيير الحجم دقيقة وسريعة جدًا. يمكنك استخدام هذه الأداة بسلاسة على جميع الأجهزة. لا حاجة لتثبيت أو تنزيل أي تطبيق. جميع الخدمات متاحة عبر الإنترنت في المتصفح الذي تختاره.',
          ],
          bullets: [
            'يمكنك تغيير حجم عدة صور (حتى 100+) دفعة واحدة باستخدام أداة تغيير الحجم. وإذا كان لديك جهاز عالي الأداء، يمكنك بسهولة تغيير حجم 400 إلى 500 صورة خلال ثوانٍ.',
            'تتم كل المعالجة داخل متصفحك المحلي. لا تحتاج إلى رفع أي صورة إلى خوادمنا. صورك لا تغادر جهازك أبدًا، لذلك يمكنك تغيير حجم صورك الشخصية دون أي مخاطر تتعلق بالخصوصية.',
            'تدعم الأداة وحدات متعددة لتغيير حجم الصور.',
            'يمكنك الحفاظ على نسبة العرض إلى الارتفاع الأصلية للصورة بعد تغيير الحجم بمجرد تحديد مربع الاختيار.',
            'إذا كنت تغيّر حجم عدة صور، يمكنك تنزيل الصور الناتجة بشكل منفصل أو كملف ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. دليل خطوة بخطوة',
          steps: [
            {
              heading: 'أولاً، اختر الصورة أو عدة صور التي تريد تغيير حجمها. لديك عدة طرق لاختيار الصور.',
              bullets: [
                'يمكنك سحب الصور وإفلاتها مباشرة لتغيير حجمها.',
                'اختصار Ctrl + V مدعوم أيضًا للصق الصورة داخل مربع الإسقاط.',
                'سيؤدي النقر على زر Choose Files إلى فتح مستكشف الملفات، ويمكنك أيضًا اختيار الصور المطلوبة لتغيير الحجم.',
              ],
            },
            {
              heading: 'ثم لديك خيار اختيار إحدى الوحدات لتغيير حجم الصورة. نحن ندعم حاليًا هذه الوحدات:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'بعد اختيار الوحدة، اضبط الارتفاع والعرض لتغيير حجم الصورة. يمكنك أيضًا قفل نسبة العرض إلى الارتفاع عبر تحديد مربع الاختيار.',
            },
            {
              heading: 'ثم فعّل خيار “Don’t enlarge if original is smaller” إذا كنت لا تريد تكبير الصورة الناتجة عن حجمها الأصلي.',
            },
            {
              heading: 'بعد ذلك، اختر خيار التنزيل.',
              bullets: [
                'اختر ZIP إذا كنت تغيّر حجم عدة صور وتريد تنزيلها كلها كملف zip واحد.',
                'أو اختر “separate” لتنزيل كل صورة بعد تغيير الحجم بشكل منفصل.',
              ],
            },
            {
              heading: 'ثم اضغط على زر “Resize & Download” لتنزيل صورك بعد تغيير الحجم وفق خيار التنزيل الذي حددته.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. فوائد أداة تغيير حجم الصور: أبرز فائدة لهذه الأداة هي وضع الصور بشكل صحيح داخل صفحات الويب ومنشورات وسائل التواصل الاجتماعي.',
          tocLabel: '4. فوائد أداة تغيير حجم الصور',
          bullets: [
            'تحسين تجربة المستخدم (UX): الحجم المناسب والوضع الصحيح للصور يعززان تجربة المستخدم بشكل كبير. وضع صور كبيرة جدًا أو صغيرة جدًا بدون ضبط مناسب يؤدي إلى تجربة مستخدم سيئة.',
            'دعم وسائل التواصل الاجتماعي: العديد من تطبيقات التواصل الاجتماعي لديها حدود أبعاد خاصة لنشر الصور. أداة تغيير حجم الصور لدينا تساعدك على ضبط صورك لتلك الأبعاد المطلوبة.',
            'تصميم متجاوب: إذا كنت مطورًا وتعمل على تصميم متجاوب، فعليك تغيير أحجام الصور لأبعاد متعددة لدعم الأجهزة المختلفة.',
            'أفضل خيار: بدلًا من تمديد الصور أو قصّها بما قد يغيّر أبعادها، فإن أداة تغيير الحجم هي الخيار الأفضل.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. الصيغ المدعومة: تتيح لك أداة تغيير حجم الصور اختيار صورة بأي صيغة لإعادة التحجيم. الصيغ كالتالي:',
          tocLabel: '5. الصيغ المدعومة',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'قص الصور — قص JPG وPNG مجاناً | photremium.com',
      uploadDesc: 'قص صور JPG وPNG وGIF عبر الإنترنت بسهولة. مجاناً وسريع وخاص.',
      uploadKeywords: 'قص الصورة، قص jpg، قص png',
      workspaceTitle: 'قص الصور — photremium.com',
      workspaceDesc: 'قص الصور عبر الإنترنت مجاناً.',
      workspaceKeywords: 'قص الصورة',
    },
    title: 'قص الصورة',
    desc: 'قص صور JPG وPNG وGIF والمزيد باستخدام المحرر المرئي.',
    toCrop: 'للقص',
    cropSettings: 'إعدادات القص',
    widthPx: 'العرض (بكسل)',
    heightPx: 'الارتفاع (بكسل)',
    positionX: 'الموضع X (بكسل)',
    positionY: 'الموضع Y (بكسل)',
    cropTemplate: 'نموذج القص',
    landscape: 'أفقي',
    portrait: 'عمودي',
    square: 'مربع',
    freeform: 'حر',
    cropping: 'جارٍ القص…',
    cropDownload: 'اقطع وحمّل',
    cropDownloadAll: 'اقطع وحمّل الكل',
    saveNext: 'احفظ والتالي',
    croppedNofTotal: 'لقد قصصت {n} من أصل {total} صورة.',
    downloadN: 'تحميل {n}',
    blog: {
      tocTitle: 'المحتوى',
      title: 'مدونة أداة قص الصور',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. لماذا تستخدم أداة قص الصور؟',
          paragraphs: [
            'أداة قص الصور هي أداة برمجية تُستخدم لقص الصورة بالشكل المطلوب. تُستخدم على نطاق واسع لقص جزء مطلوب من الصورة وإزالة الجزء الخارجي غير المرغوب فيه لأي غرض. وهي توفر مربع قص يمكنك ضبطه في الموضع الذي تريد القص فيه.',
          ],
          listTitle: 'على سبيل المثال:',
          bullets: [
            'قص صورتك الخاصة من صورة جماعية.',
            'قص اسمك من قائمة.',
            'قص شريط التقدم من لقطة شاشة كاملة.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. لماذا تختار أداة قص الصور الخاصة بنا؟',
          paragraphs: [
            'تتيح لك أداة قص الصور الخاصة بنا قص الصور بدقة وبسرعة كبيرة. كل ما عليك هو ضبط حجم مربع القص في الموضع الذي تريد قصّه من أي صورة. يتم دعم تقريبًا جميع صيغ الصور عند اختيار الصورة.',
          ],
          bullets: [
            'يمكنك قص عدد الصور الذي يدعمه جهازك. إذا كان لديك جهاز عالي الأداء، يمكنك قص أكثر من 100 صورة دفعة واحدة بدون بطء أو أي مشاكل أخرى.',
            'ستتم معالجة صورك على متصفحك المحلي. لا حاجة لرفع أي صورة إلى خوادمنا، لذلك لا تغادر أي صورة جهازك. يمكنك قص صورك الشخصية بدون أي عدم أمان أو مخاطر.',
            'تقوم العديد من الأدوات بإظهار خطأ صيغة صورة غير صالحة. تتعامل أداة قص الصور الخاصة بنا مع هذه المشكلة عبر دعم تقريبًا جميع صيغ الصور.',
            'إذا كنت تقص عدة صور دفعة واحدة، فإن أداتنا تتيح لك تنزيل الصور المقصوصة كملف ZIP أو كصور منفصلة حسب تفضيلك.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. دليل خطوة بخطوة',
          steps: [
            {
              heading: '1. أولًا، اختر الصورة التي تريد قصها. كما أن أداة قص الصور الخاصة بنا تدعم اختيار عدة صور دفعة واحدة.',
              bullets: [
                'اسحب وأفلت الصورة في مربع الإسقاط لقصها.',
                'يمكنك أيضًا اختيار الصورة عبر مستكشف الملفات بالنقر على زر choose files الموجود داخل مربع القص.',
                'يتم دعم اختصار Ctrl + V أيضًا للصق الصور داخل مربع الإسقاط.',
              ],
            },
            {
              heading: '2. ثم اضبط حجم وموضع مربع القص على الصورة لقصها.',
            },
            {
              heading: '3. يمكنك أيضًا ضبط مربع القص بإدخال قيم الارتفاع والعرض والموضع الأفقي والموضع العمودي يدويًا.',
            },
            {
              heading: '4. يمكنك أيضًا استخدام بعض القوالب الجاهزة:',
              bullets: [
                'أفقي(16:9)',
                'عمودي(9:16)',
                'مربع(1:1)',
              ],
            },
            {
              heading: '5. ثم عليك اختيار أحد خيارات التنزيل.',
              bullets: [
                'ZIP: اختر هذا الخيار إذا كنت تقص عدة صور وتريد تنزيل جميع الصور المقصوصة كملف واحد.',
                'Separate: إذا كنت تريد تنزيل جميع الصور المقصوصة بشكل منفصل، فاختر هذا الخيار من زر التبديل.',
              ],
            },
            {
              heading: '6. ثم انقر على زر Crop & Download لتنزيل جميع صورك المقصوصة وفقًا لأبعادك المحددة مسبقًا.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. فوائد أداة قص الصور: توفر أداة قص الصور عدة فوائد في العالم الرقمي. بعض هذه الفوائد موضحة أدناه:',
          tocLabel: '4. فوائد أداة قص الصور',
          bullets: [
            'ملاءمة الصور داخل الإطارات: تساعدك أداة قص الصور على ملاءمة الصور بشكل صحيح داخل الإطارات. يمكن أن تكون هذه الإطارات في صفحة ويب أو على أي منصة تواصل اجتماعي.',
            'تعزيز تجربة المستخدم UX: بما أن وضع الصور بشكل صحيح يعزز تجربة المستخدم، فإن أداة قص الصور تساعد على تعزيز UX إلى حد كبير.',
            'إزالة الحدود غير المرغوب فيها: يمكنك إزالة أي حدود غير مرغوب فيها من الصورة لتحسينها.',
            'فصل العنصر المطلوب: يمكنك أيضًا فصل صورتك من صورة جماعية.',
            'توفير المساحة التخزينية: قص الصورة يوفر المساحة التخزينية بالتأكيد لأن المنطقة الخام من الصورة يتم قصها ولا يتم حفظ سوى الجزء المطلوب.',
            'تحسين العروض التقديمية: بما أن عرضًا تقديميًا عاديًا يحتوي على 10 صور غير مقصوصة قد يستهلك قرابة 30MB من التخزين، فإن العرض نفسه مع الصور المقصوصة قد يستهلك قرابة 10MB من التخزين.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. الصيغ المدعومة:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'محرر الصور — تحرير الصور مجاناً | photremium.com',
      desc: 'حرّر الصور عبر الإنترنت مجاناً — أضف نصاً وتأثيرات وإطارات والمزيد.',
      keywords: 'محرر الصور، تحرير الصور عبر الإنترنت',
    },
    title: 'محرر الصور',
    desc: 'أضف نصاً وتأثيرات وإطارات وملصقات إلى صورك.',
    toEdit: 'للتحرير',
    textTypography: 'النص والخطوط',
    textTypographyDesc: 'أضف نصاً مخصصاً بخطوط وألوان وظلال متنوعة.',
    filtersEffects: 'الفلاتر والتأثيرات',
    filtersEffectsDesc: 'طبّق فلاتر احترافية واضبط السطوع والتباين والتشبع.',
    framesStickers: 'الإطارات والملصقات',
    framesStickersDesc: 'اختر من إطارات جميلة وملصقات ممتعة.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'إزالة خلفية الصورة مجاناً | photremium.com',
      uploadDesc: 'أزِل خلفيات الصور بدقة عالية. مجاناً — يعمل في متصفحك.',
      uploadKeywords: 'إزالة الخلفية، إزالة خلفية الصورة، خلفية شفافة',
      workspaceTitle: 'إزالة الخلفيات — photremium.com',
      workspaceDesc: 'إزالة خلفيات الصور مجاناً.',
      workspaceKeywords: 'إزالة الخلفية',
    },
    title: 'إزالة الخلفية',
    desc: 'أزِل خلفيات الصور فوراً. 100% مجاني، يعمل في متصفحك.',
    toRemoveBg: 'لإزالة الخلفية',
    backgroundRemover: 'أداة إزالة الخلفية',
    processingProgress: 'تقدم المعالجة',
    processingNImages: 'جارٍ معالجة {n} صورة…',
    allNProcessed: 'تمت معالجة {n} صورة!',
    nOfTotalDone: '{n} / {total} مكتمل',
    fileName: 'اسم الملف',
    dimensions: 'الأبعاد',
    status: 'الحالة',
    statusDone: '✓ تم',
    statusProcessing: '⏳ معالجة',
    statusError: '✗ خطأ',
    statusPending: '⏸ انتظار',
    badgeDone: 'تم',
    badgeProcessing: 'جارٍ المعالجة…',
    badgeError: 'خطأ',
    removingBg: 'جارٍ إزالة الخلفية…',
    retry: 'إعادة المحاولة',
    downloading: 'جارٍ التنزيل…',
    nextImage: 'الصورة التالية',
  },

  watermark: {
    seo: {
      uploadTitle: 'إضافة علامة مائية للصور مجاناً | photremium.com',
      uploadDesc: 'أضف علامات مائية نصية أو صورية إلى صورك. مجاناً وسريع.',
      uploadKeywords: 'علامة مائية، إضافة علامة مائية',
      workspaceTitle: 'إضافة علامة مائية — photremium.com',
      workspaceDesc: 'إضافة علامات مائية للصور مجاناً.',
      workspaceKeywords: 'علامة مائية',
    },
    title: 'إضافة علامة مائية',
    desc: 'أضف علامات مائية نصية أو شعارات إلى صورك.',
    toWatermark: 'لإضافة علامة مائية',
    watermarkTools: 'أدوات العلامة المائية',
    addText: 'إضافة نص',
    addImage: 'إضافة صورة',
    layersN: 'الطبقات ({n})',
    noLayers: 'لا توجد طبقات مضافة بعد',
    textLayer: 'طبقة نص',
    imageLayer: 'طبقة صورة',
    watermarkDownloadAll: 'إضافة علامة مائية وتحميل الكل',
    watermarkDownload: 'إضافة علامة مائية وتحميل',
    nextImage: 'الصورة التالية',
    privateMode: 'الوضع الخاص',
    privateModeOn: 'الوضع الخاص مفعّل: تحريك وتغيير حجم العلامات المائية فقط…',
    privateModeHint: 'فعّل الوضع الخاص لضبط الموضع والحجم فقط…',
    privateModeActive: 'الوضع الخاص — التحريك وتغيير الحجم وتغيير حجم الخط فقط مسموح',
    selectToEdit: 'اختر أي صورة أو نص لبدء التحرير',
    bold: 'عريض',
    italic: 'مائل',
    underline: 'تسطير',
    bgColor: 'لون الخلفية',
    textColor: 'لون النص',
    alignLeft: 'محاذاة يسار',
    alignCenter: 'محاذاة وسط',
    alignRight: 'محاذاة يمين',
    opacity: 'الشفافية',
    stroke: 'الحد',
    strokeWidth: 'عرض الحد',
    strokeColor: 'لون الحد',
    tileRepeat: 'تكرار / تبليط',
    tilePattern: 'نمط التبليط',
    spacing: 'التباعد',
    snapToCenter: 'محاذاة إلى المركز',
    duplicate: 'تكرار',
    delete: 'حذف',
    flipHorizontal: 'عكس أفقي',
    flipVertical: 'عكس عمودي',
    rotateLeft: 'تدوير يسار',
    rotateRight: 'تدوير يمين',
    cornerRadius: 'نصف قطر الزاوية',
    borderStroke: 'الحدود / الخط',
    borderWidth: 'عرض الحدود',
    color: 'اللون',
    style: 'النمط',
    hide: 'إخفاء',
    show: 'إظهار',
    lock: 'تأمين',
    unlock: 'إلغاء التأمين',
    solid: 'صلب',
    dashed: 'متقطع',
    dotted: 'منقط',
    double: 'مزدوج',
    tileSingle: 'مفرد',
    tile2x2: 'شبكة 2×2',
    tile3x3: 'شبكة 3×3',
    removeAllConfirm: 'حذف جميع الصور والعلامات المائية؟',
    dimMismatch: 'الصور التي رفعتها لها أبعاد مختلفة. حاول رفع صور بنفس الدقة للحصول على أفضل النتائج.',
    clearBackground: 'مسح الخلفية',
    typeHere: 'اكتب هنا...',
    linkCorners: 'ربط الزوايا',
    separateCorners: 'فصل الزوايا',
    blog: {
      tocTitle: 'المحتويات',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'نظرة عامة على الأداة',
          title: 'كيفية إضافة علامة مائية إلى صورك عبر الإنترنت — الدليل الكامل لأداة العلامة المائية من Photremium',
          paragraphs: [
            'لقد انتهيت للتو من تعديل صورة جميلة. ربما هي لقطة منتج لمتجرك، أو بورتريه من جلسة عميل، أو عمل فني رقمي قضيت ساعات في إتقانه. والآن يظهر السؤال الذي يواجهه كل مبدع في النهاية: كيف تحميه قبل مشاركته؟',
            'الجواب الذي يصل إليه معظم المحترفين هو العلامة المائية — ولسبب وجيه. العلامة المائية الموضوعة بشكل صحيح تعمل كتوقيع دائم لعملك، ما يجعلها قابلة للتتبع وممهورة بعلامتك ويصعّب سرقتها بشكل كبير.',
            'المشكلة التي يواجهها معظم الناس: الأدوات المتاحة عبر الإنترنت إما معقدة وبطيئة، أو محجوبة باشتراكات، أو تُنتج علامة مائية ثقيلة تفسد الصورة بالكامل.',
            'تم تصميم أداة العلامة المائية في Photremium لحل كل ذلك. إنها مساحة عمل مجانية بالكامل تعمل في المتصفح دون حساب، ولا ترفع ملفاتك إلى أي خادم. كل شيء يبقى محلياً وسريعاً، ومستوى التحكم الإبداعي ينافس تطبيقات سطح المكتب الاحترافية. في هذا الدليل سنشرح بالضبط كيف تعمل الأداة، ولمن صُممت، وكيف تحصل على أفضل نتائج ممكنة في كل مرة.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'ما هي العلامة المائية',
          title: 'ما هي العلامة المائية ولماذا تهم؟',
          paragraphs: [
            'قبل التعمق في الأداة نفسها، يجدر فهم ما تفعله العلامة المائية ولماذا يعتبرها كثير من المصورين والمصممين وصنّاع المحتوى أمراً غير قابل للتفاوض.',
            'العلامة المائية هي طبقة مرئية تُضاف إلى الصورة — عادة نص أو شعار أو رمز حقوق نشر — لتحديد منشئ المحتوى أو مالكه. وعلى عكس البيانات الوصفية المخفية داخل الملف ويمكن إزالةها خلال ثوانٍ، فإن العلامة المائية تكون مدمجة بصرياً في الصورة نفسها. لا يمكنك إزالةها بمجرد النقر بزر الماوس الأيمن دون إضعاف جودة الصورة بشكل واضح.',
          ],
          subSections: [
            {
              title: 'لماذا يستخدم المبدعون العلامات المائية',
              paragraphs: [
                'الأسباب العملية لوضع علامة مائية على صورك تتلخص في ثلاث نقاط أساسية.',
              ],
              bullets: [
                'تحديد الملكية. عندما تتم مشاركة عملك على منصات التواصل أو Pinterest أو تضمينه في مقالات، غالباً ما تُزال الإشارة للمصدر الأصلي. العلامة المائية تضمن أن اسمك أو علامتك تنتقل مع الصورة أينما ذهبت.',
                'ردع السرقة. معظم سارقي الصور يبحثون عن الطريق الأسهل. علامة مائية احترافية وموضوعة بذكاء وبقدر مناسب من الشفافية ترسل رسالة واضحة: هذه الصورة مملوكة لشخص يهتم بعمله.',
                'حماية معرض أعمال العملاء. المصورون الذين يشاركون معاينات مع العملاء قبل الدفع يستخدمون العلامات المائية لمنع استخدام المعاينات دون تسوية الفاتورة. العلامة المائية الخفيفة تحقق ذلك دون تشتيت التقييم.',
              ],
            },
            {
              title: 'من الذي يجب أن يستخدم العلامة المائية؟',
              paragraphs: [
                'إذا كنت ضمن أي من الفئات التالية، فإن وضع علامة مائية قبل مشاركة صورك على الإنترنت ليس خياراً — بل ضرورة:',
              ],
              bullets: [
                'المصورون المستقلون الذين يشاركون معرضاً مع العملاء',
                'المصممون الذين ينشرون عينات من أعمالهم',
                'بائعو التجارة الإلكترونية الذين يعرضون صور المنتجات قبل الترخيص',
                'الفنانون الرقميون الذين يشاركون أعمالهم على الشبكات الاجتماعية',
                'المدونون وصنّاع المحتوى الذين يُعاد استخدام صورهم كثيراً',
                'مساهمو الصور المخزنة الذين يبنون علامة تجارية معروفة',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'لوحات مساحة العمل',
          title: 'داخل أداة العلامة المائية في Photremium: مساحة عمل بثلاث لوحات لعمليات حقيقية',
          paragraphs: [
            'ما يميز أداة العلامة المائية في Photremium عن أدوات العلامة المائية البسيطة هو تصميم مساحة العمل. بدلاً من نهج بسيط من نوع "اكتب النص، اختر الموضع، تم"، توفر الأداة تخطيطاً بثلاث لوحات يشبه ما تجده في برامج التصميم الاحترافية — لكنه يعمل بالكامل في متصفحك دون أي تثبيت.',
          ],
          subSections: [
            {
              title: 'لوحة القماش اليسرى',
              paragraphs: [
                'تأخذ لوحة القماش أكبر مساحة من الشاشة وتعرض لك صورتك مع العلامة المائية في الوقت الحقيقي. أي تغيير تجريه — تعديل الشفافية، تحريك طبقة نصية، تغيير حجم شعار — يظهر فوراً على القماش. لا يوجد زر "معاينة". ما تراه هو ما تحصل عليه.',
                'تتضمن لوحة القماش أيضاً شريط تكبير مدمج، يتيح لك التكبير للمحاذاة الدقيقة والتصغير لرؤية الصورة كاملة. ميزة الملاءمة التلقائية تحدد أفضل مقياس ابتدائي حسب حجم شاشتك، لذلك حتى الصور عالية الدقة تظهر بحجم مريح. تظهر أدلة محاذاة ديناميكية عندما تسحب طبقة قرب مركز الصورة أفقياً أو عمودياً، وتقوم بعملية سناب مبهرة إلى المنتصف كما في فوتوشوب.',
              ],
            },
            {
              title: 'لوحة الإعدادات اليمنى',
              paragraphs: [
                'اللوحة اليمنى هي مركز التحكم. هنا تدير طبقات العلامة المائية، وتخصص مظهرها، وتنفذ التصدير النهائي. على سطح المكتب تكون مثبتة في الجانب الأيمن. وعلى الأجهزة المحمولة تظهر كلوحة سفلية تُفتح بزر عائم، بحيث لا تغطي القماش أثناء العمل.',
                'داخل اللوحة اليمنى ستجد مدير الطبقات، الذي يسرد كل عنصر علامة مائية أضفته. كل عنصر يُظهر نوع الطبقة (نص أو صورة)، والاسم أو المحتوى الحالي، وثلاثة أزرار سريعة: زر إظهار/إخفاء (أيقونة العين)، زر قفل لتجميد الموضع أثناء العمل على طبقات أخرى، وزر حذف.',
              ],
            },
            {
              title: 'شريط المعاينة الأيسر (وضع تعدد الصور)',
              paragraphs: [
                'عند العمل على عدة صور — مثل مجموعة صور منتجات أو جلسة كاملة — يظهر شريط مصغرات عمودي في أقصى اليسار. هذا هو طابور الصور، ويعرض معاينات لكل الملفات. بالنقر على أي مصغرة تنتقل القماشة لتلك الصورة فوراً، لتتحقق من مظهر العلامة المائية على تركيبات مختلفة دون فقدان إعدادات الطبقات.',
                'يعرض الشريط أيضاً حجم كل ملف بالكيلوبايت أو الميغابايت مع وسم الصيغة (JPG, PNG, WEBP)، لتعرف ما تعمل عليه بسرعة.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'خطوة بخطوة',
          title: 'خطوة بخطوة: كيفية إضافة علامة مائية على صورتك في Photremium',
          paragraphs: [
            'هذا الشرح مبني مباشرة على كيفية عمل الأداة داخلياً — من نظام الرفع بالسحب والإفلات إلى محرك الرسم على القماش الذي يدمج العلامة المائية نهائياً قبل التحميل.',
          ],
          steps: [
            {
              heading: 'الخطوة 1 — ارفع صورتك/صورك',
              paragraphsBefore: [
                'اذهب إلى photremium.com/watermark-image. ستصل إلى شاشة الرفع، وفيها منطقة إسقاط نظيفة في منتصف الصفحة.',
                'لديك ثلاث طرق لإدخال الصورة إلى الأداة:',
              ],
              bullets: [
                'السحب والإفلات. اسحب ملفاً واحداً أو أكثر من سطح المكتب وأسقطه في منطقة الإسقاط. الأداة تقبل أي صيغة صور شائعة — JPEG وPNG وWEBP وغيرها. عند سحب الملفات فوق مساحة العمل يظهر إطار أرجواني حول المنطقة كلها مع رسالة "Drop images to add for watermarking" لتأكيد التعرف على الإسقاط.',
                'النقر للاستعراض. انقر زر "Choose Files" داخل منطقة الإسقاط لفتح محدد الملفات. يمكنك اختيار ملفات متعددة باستخدام Ctrl+Click (ويندوز) أو Cmd+Click (ماك).',
                'اللصق من الحافظة. إذا نسخت صورة إلى الحافظة — من لقطة شاشة أو تطبيق آخر أو المتصفح — اضغط Ctrl+V (أو Cmd+V على ماك) أثناء وجودك في صفحة العلامة المائية وستُحمّل الصورة مباشرة. يعمل هذا حتى مع وجود عدة صور محمّلة.',
              ],
              paragraphsAfter: [
                'بمجرد تحميل أول صورة، تنتقل الواجهة من شاشة الرفع إلى محرر اللوحات الثلاث، وتظهر الصورة على القماش بمستوى تكبير مناسب تلقائياً للشاشة.',
              ],
            },
            {
              heading: 'الخطوة 2 — إضافة طبقة علامة مائية نصية',
              paragraphsBefore: [
                'انقر زر "Add Text" البنفسجي في اللوحة اليمنى. ستظهر طبقة نص جديدة على القماش مع نص افتراضي "Type here..." محدداً تلقائياً.',
                'يمكنك البدء بالكتابة مباشرة. يظهر النص على القماش باللون الأبيض وخط Arial بحجم افتراضي مضبوط على أبعاد الصورة. من شريط الأدوات العلوي الذي يظهر عند تحديد طبقة النص يمكنك تخصيص كل شيء:',
              ],
              bullets: [
                'عائلة الخط — اختر من 12 خطاً مدمجاً مثل Arial وGeorgia وImpact وBrush Script MT وComic Sans MS وغيرها',
                'حجم الخط — اكتب قيمة بالبكسل مباشرة أو استخدم أزرار الزيادة والنقصان',
                'عريض، مائل، تحته خط — فعّل أي تركيبة من هذه الأنماط',
                'لون النص — انقر عيّنة اللون لفتح منتقي الألوان واختيار أي لون سداسي',
                'لون الخلفية — أضف خلفية ملونة خلف النص لمظهر شارة أو بطاقة',
                'حد (Stroke) — اضبط سماكة الحد ولونه لتحسين وضوح القراءة على الصور الفاتحة والداكنة',
                'الشفافية — حرّك الشفافية من 0% (غير مرئي) إلى 100% (ظاهر بالكامل). أغلب العلامات المائية تكون بين 30% و60%',
                'المحاذاة — يسار أو وسط أو يمين داخل صندوق النص',
                'الدوران — دوّر طبقة النص لأي زاوية، مع نقاط تثبيت مغناطيسية عند 0° و90° و180° و270° للوضع المستقيم بسرعة',
              ],
              paragraphsAfter: [
                'لتحريك النص، انقر واسحب في أي مكان على القماش. لضبط دقيق بالبكسل، استخدم أسهم لوحة المفاتيح (مع الضغط على Shift للتحرك 10 بكسلات). لتغيير حجم صندوق النص، اسحب أيّاً من مقابض التحجيم الثمانية حول الطبقة.',
              ],
            },
            {
              heading: 'الخطوة 3 — إضافة علامة مائية بصورة (شعار)',
              paragraphsBefore: [
                'إذا أردت استخدام شعار أو توقيع أو أي صورة كعلامة مائية بدلاً من النص — أو بالإضافة إليه — انقر زر "Add Image" الأزرق في اللوحة اليمنى. سيفتح محدد الملفات لتختار صورة العلامة المائية من جهازك.',
                'تقوم الأداة تلقائياً بتغيير حجم صورة العلامة المائية إلى نحو 30% من عرض القماش مع الحفاظ على النسبة، وتضعها في منتصف القماش. بعد ذلك يمكنك سحبها لأي موضع، وتغيير حجمها من مقابض الزوايا (مع الحفاظ على النسبة)، أو تدويرها باستخدام مقبض الدوران المخصص أعلى الطبقة.',
                'بالنسبة لطبقات العلامة المائية من نوع الصورة، توفر اللوحة اليمنى عناصر تحكم إضافية:',
              ],
              bullets: [
                'الشفافية — مثل طبقات النص، مثالية لشعارات PNG الشفافة',
                'عكس أفقي / عكس عمودي — عكس العلامة المائية عند الحاجة',
                'عرض الحد ولون الحد ونمط الحد — أضف إطاراً مرئياً حول شعار العلامة المائية',
                'نصف قطر الزوايا — تدوير زوايا الشعار بشكل موحد أو منفصل لكل زاوية',
                'الدوران — نفس سلوك الدوران السلس في طبقات النص',
              ],
            },
            {
              heading: 'الخطوة 4 — ضبط التبليط (اختياري)',
              paragraphsBefore: [
                'إحدى الميزات القوية في الأداة هي التبليط — أي تكرار العلامة المائية عبر الصورة كلها بنمط شبكة. هذا مفيد عندما تريد جعل الصورة غير قابلة لإعادة النشر أكثر من مجرد وضع علامة.',
                'مع تحديد طبقة، ابحث عن خيار التبليط في شريط الأدوات. يمكنك اختيار:',
              ],
              bullets: [
                'None — موضع واحد (افتراضي)',
                'Grid 2×2 — يكرر العلامة المائية بنمط 2 عمود × 2 صف',
                'Grid 3×3 — يكررها بنمط 3×3 لكثافة أعلى',
              ],
              paragraphsAfter: [
                'يمكنك أيضاً ضبط تباعد التبليط للتحكم بالمسافة بين النسخ. يعرض القماش معاينات شبحية لكل النسخ لتشاهد التغطية قبل التحميل.',
              ],
            },
            {
              heading: 'الخطوة 5 — استخدام مدير الطبقات لعلامات متعددة',
              paragraphsBefore: [
                'يمكنك إضافة عدد غير محدود من الطبقات — نصوص وصور معاً. مدير الطبقات في اللوحة اليمنى يسردها كلها. يمكنك:',
              ],
              bullets: [
                'إظهار/إخفاء الطبقات عبر أيقونة العين — مفيد لتبديل نسخ مختلفة دون حذف',
                'قفل طبقة لمنع تحريكها بالخطأ أثناء العمل على أخرى',
                'حذف طبقة نهائياً',
              ],
              paragraphsAfter: [
                'النقر على أي عنصر طبقة في القائمة يحدده على القماش في نفس الوقت، ما يسهل التنقل بين الطبقات دون البحث عنها في الصورة.',
              ],
            },
            {
              heading: 'الخطوة 6 — التبديل بين صور متعددة',
              paragraphsBefore: [
                'إذا رفعت أكثر من صورة، استخدم شريط المصغرات على اليسار للتبديل بين الصور في القماش. طبقات العلامة المائية التي أعددتها تُطبق على جميع الصور عند التصدير.',
                'تُجري الأداة أيضاً فحصاً لتناسق الدقة عبر مجموعتك. إذا كانت الأبعاد مختلفة بشكل ملحوظ (أكثر من 5% في العرض أو الارتفاع)، يظهر تحذير بأن الموضع قد يبدو مختلفاً بسبب اختلاف المقاسات. يتعامل المحرك مع ذلك عبر خوارزمية نسبية: يحسب موضع العلامة كنسبة من أبعاد الصورة المرجعية ويطبق النسبة نفسها على بقية الصور، مع الحفاظ على النية البصرية حتى مع اختلاف الدقة.',
              ],
            },
            {
              heading: 'الخطوة 7 — ضبط تفضيلات التحميل',
              paragraphsBefore: [
                'للعمل على صورة واحدة، انقر زر "Download" أسفل القماش لحفظ الصورة المائية مباشرة. يتم إعداد اسم الملف تلقائياً بإضافة "-watermarked" قبل الامتداد. تُصدّر صور JPEG بجودة 0.95 — عالية بما يكفي لعدم تمييزها عن الأصل في العرض العادي. وتُصدّر صور PNG بدون فقد.',
                'لأعمال الدُفعات (صور متعددة)، لديك وضعان للتحميل في اللوحة اليمنى:',
              ],
              bullets: [
                'ZIP — تُحزم كل الصور المائية في ملف ZIP واحد يُحمّل بنقرة واحدة. تستخدم الأداة JSZip ديناميكياً للضغط.',
                'Separate — تُحمّل كل صورة كملف مستقل مع تأخير قصير لمنع قيود المتصفح.',
              ],
            },
            {
              heading: 'الخطوة 8 — التحميل والتحقق',
              paragraphsBefore: [
                'بعد النقر على زر التحميل (أو زر "Watermark & Download All" للدُفعات)، تقوم الأداة برسم كل صورة على لوحة Canvas مخفية بدقة كاملة — وليس بحجم المعاينة المعروض على الشاشة. هذا يعني أن الصورة الناتجة تكون بدقة أصلية 100% مع العلامة المائية بالحجم النسبي الصحيح. افتح الملف المُحمّل وكبّر للتحقق من الموضع والجودة.',
                'إذا بدا أي شيء غير مناسب، ببساطة عد إلى مساحة العمل — طبقاتك ما تزال موجودة — عدّل ثم حمّل مرة أخرى.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'نصائح احترافية',
          title: 'نصائح احترافية للحصول على أفضل النتائج',
          bullets: [
            'استخدم شعار PNG شبه شفاف لاحترافية أعلى. العلامة المائية بالشعار مع خلفية شفافة وبشفافية 40–50% تبدو أنظف من النص الصلب. صدّر الشعار من أداة التصميم كـ PNG مع شفافية قبل استخدامه.',
            'ضع العلامة المائية في مكان يضر قصّه بالقيمة. الزاوية اليمنى السفلية هي الأكثر شيوعاً والأسهل في القص. لحماية أقوى، ضع العلامة فوق عنصر بصري مهم مثل وجه أو تفصيلة منتج أو نقطة التركيز. خيار التبليط القطري أصعب في الإزالة دون إتلاف الصورة.',
            'استخدم ميزة القفل عند العمل بطبقات متعددة. بعد ضبط موقع العلامة الأساسية، اقفل الطبقة قبل إضافة أخرى. هذا يمنع تحريكها بالخطأ.',
            'اختبر مناطق فاتحة ومظلمة. العلامة البيضاء تختفي على السماء الساطعة لكنها واضحة على الظلال الداكنة. أضف حدّاً خفيفاً أو خلفية لتحسين القراءة فوق أي محتوى.',
            'اختصارات لوحة المفاتيح توفر وقتاً دائماً. الأسهم تحرك الطبقة بكسل واحد. Shift+Arrow يحركها 10 بكسلات. زر Delete يحذف الطبقة مباشرة. هذا يجعل الضبط الدقيق أسرع من السحب.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'الخصوصية والأمان',
          title: 'الخصوصية والأمان: لماذا المعالجة داخل المتصفح مهمة',
          paragraphs: [
            'أحد مخاوف المبدعين عند استخدام الأدوات عبر الإنترنت هو أين تذهب صورهم فعلاً. في أدوات العلامة المائية المعتمدة على الخادم، تُرفع الصورة إلى خوادم المزود ليتم معالجتها ثم تُعاد إليك. هذا يعني أن أعمالك غير المنشورة وصور العملاء أو منتجات حساسة تمر عبر بنية طرف آخر.',
            'أداة العلامة المائية في Photremium تعالج كل شيء محلياً في متصفحك. تُحمّل صورك إلى ذاكرة جهازك عبر File API ولا تُنقل عبر الإنترنت. يتم رسم العلامة المائية على عنصر Canvas باستخدام JavaScript داخل تبويب المتصفح. عند إغلاق الصفحة أو الضغط على "Start Over"، يتم تحرير بيانات الصور من الذاكرة وحذفها. لا يتم تخزين أي شيء خارج جهازك.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'الخلاصة النهائية',
          title: 'لماذا تستحق أداة العلامة المائية في Photremium مكاناً دائماً في سير عملك',
          paragraphs: [
            'هناك عشرات أدوات العلامة المائية المتاحة عبر الإنترنت. ما يميز أداة تستحق الحفظ من أخرى تُنسى هو مزيج من السرعة والتحكم والثقة.',
            'السرعة مهمة لأن وضع العلامة المائية لا ينبغي أن يضيف وقتاً كبيراً إلى سير عملك. أداة Photremium تُحمّل فوراً وتعالج محلياً وتصدّر بدقة كاملة في ثوانٍ — حتى مع الدُفعات الكبيرة. لا يوجد انتظار لمعالجة الخوادم أو طوابير أو زمن يتأثر بعدد المستخدمين المتصلين.',
            'التحكم مهم لأن العلامة المائية السيئة أسوأ من عدمها — فهي تجعل علامتك تبدو غير احترافية. نظام الطبقات والتحكمات لكل خاصية والمعاينة الحية والاختصارات كلها تخلق مستوى تحكم يقارب برامج سطح المكتب الاحترافية.',
            'الثقة مهمة لأن أعمالك غير المنشورة ثمينة. معرفة أن صورك لا تغادر جهازك ولا تمر عبر خوادم طرف ثالث تعني أنك تستطيع وضع علامات مائية على صور العملاء أو منتجات غير معلنة أو أعمال حساسة دون القلق من سياسات مزود أو تسريبات.',
            'سواء كنت تضيف إشعار حقوق نشر سريعاً لصورة واحدة أو تعالج جلسة كاملة من 200 صورة قبل مشاركة معرض عميل، فإن أداة العلامة المائية في Photremium تمنحك ما تحتاجه لتفعل ذلك بشكل صحيح — مجاناً بالكامل، بخصوصية كاملة، وبمرونة إبداعية تجعل العلامة المائية تبدو جزءاً من الصورة لا شيئاً ملصقاً فوقها.',
            'توجه إلى photremium.com/watermark-image وجرّبها. صورتك المائية الأولى تبعد حرفياً ثلاثين ثانية فقط.',
            'يقدم Photremium مجموعة من أدوات معالجة الصور التي تعمل داخل المتصفح. كل الأدوات تعمل محلياً — صورك تبقى على جهازك.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'مولّد رمز QR — إنشاء وتخصيص مجاناً | photremium.com',
      inputDesc: 'أنشئ رموز QR مخصصة للروابط والنصوص وWiFi وجهات الاتصال والبريد الإلكتروني وخرائط Google.',
      inputKeywords: 'مولّد رمز qr، إنشاء رمز qr، رمز qr مخصص',
      customizeTitle: 'تخصيص رمز QR — photremium.com',
      customizeDesc: 'خصّص نمط رمز QR ولونه وإطاره وشعاره.',
      customizeKeywords: 'تخصيص رمز qr، ألوان رمز qr',
    },
    title: 'مولّد رمز QR',
    desc: 'أنشئ وخصّص وحمّل رموز QR للروابط والنصوص وWiFi وجهات الاتصال والبريد الإلكتروني.',
    generate: 'إنشاء',
    scanQrCode: 'مسح رمز QR',
    tabUrl: 'رابط / URL',
    tabText: 'نص',
    tabWifi: 'WiFi',
    tabContact: 'جهة اتصال',
    tabEmail: 'Gmail',
    tabMaps: 'خرائط Google',
    enterUrl: 'أدخل URL',
    enterText: 'أدخل نصاً',
    networkName: 'اسم الشبكة (SSID)',
    password: 'كلمة المرور',
    encryption: 'التشفير',
    hiddenNetwork: 'شبكة مخفية',
    contactName: 'اسم جهة الاتصال (اختياري)',
    phoneNumber: 'رقم الهاتف',
    emailAddress: 'عنوان البريد الإلكتروني',
    subject: 'الموضوع (اختياري)',
    body: 'النص (اختياري)',
    searchLocation: 'البحث عن موقع',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'اكتب نصك هنا…',
    wifiNamePlaceholder: 'شبكتي',
    passwordPlaceholder: 'كلمة المرور',
    contactPlaceholder: 'محمد علي',
    phonePlaceholder: '+966 5X XXX XXXX',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'الموضوع',
    bodyPlaceholder: 'نص الرسالة…',
    locationPlaceholder: 'ابحث عن مدينة أو عنوان أو مكان…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'لا شيء',
    characters: 'حرف',
    qrGettingComplex: 'رمز QR يصبح معقداً — قد يكون من الصعب مسحه.',
    qrTooComplex: 'رمز QR معقد جداً! ستفشل معظم الماسحات في قراءته.',
    generateCustomize: 'إنشاء وتخصيص',
    editQrData: 'تحرير بيانات QR',
    styleShape: 'النمط والشكل',
    colorTab: 'اللون',
    framesTab: 'الإطارات',
    logoTab: 'الشعار',
    templatesTab: 'القوالب',
    fileFormatTab: 'تنسيق الملف',
    dotShape: 'شكل النقطة',
    cornerEyeOuter: 'عين الزاوية — خارجي',
    cornerEyeInner: 'عين الزاوية — داخلي',
    fgColor: 'لون المقدمة',
    bgColor: 'لون الخلفية',
    enableGradient: 'تفعيل التدرج',
    gradientType: 'نوع التدرج',
    linear: 'خطي',
    radial: 'دائري',
    gradientColor1: 'لون التدرج 1',
    gradientColor2: 'لون التدرج 2',
    suggestedGradients: 'تدرجات مقترحة',
    selectFrame: 'اختر إطاراً',
    selectLogo: 'اختر شعاراً',
    uploadCustomLogo: 'أو ارفع شعاراً مخصصاً',
    uploadImage: 'رفع صورة',
    customLogoApplied: 'تم تطبيق الشعار المخصص',
    premadeTemplates: 'قوالب جاهزة',
    templateHint: 'انقر على قالب لتطبيق تركيبة نمطه فوراً.',
    downloadFormat: 'تنسيق التنزيل',
    fgBgIdentical: 'ألوان المقدمة والخلفية متطابقة — سيكون رمز QR غير مرئي!',
    fgBgSimilar: 'ألوان المقدمة والخلفية متشابهة جداً — قد يكون رمز QR صعب المسح.',
    preview: 'معاينة',
    angle: 'الزاوية',
    downloadFormatBtn: 'تحميل {format}',
    pngDesc: 'بدون فقدان، دعم الشفافية',
    jpgDesc: 'تنسيق شائع/عالمي للملفات',
    webpDesc: 'تنسيق حديث، أفضل جودة/حجم',
    svgDesc: 'رسومات متجهة قابلة للتوسع',
    pdfDesc: 'مستند جاهز للطباعة',
    lat: 'خط العرض:',
    lng: 'خط الطول:',
    qrCode: 'رمز QR',
    scanMe: 'امسح',
    scanHere: 'امسح هنا',
    blog: {
      card1: {
        title: '1. ما هو رمز QR؟',
        intro1: 'الاسم الكامل لرمز QR هو Quick Response code أي رمز الاستجابة السريعة. ولأن المعلومات المخزنة فيه تُفك بسرعة كبيرة جدًا، سُمّي برمز الاستجابة السريعة (QR).',
        intro2: 'رمز QR هو رمز رقمي ثنائي الأبعاد يمكن للآلات قراءته فقط. لا يستطيع الإنسان قراءة البيانات داخله مباشرة. يحتوي على وحدات تخزّن معلومات مثل النصوص وأرقام الاتصال والروابط ومواقع خرائط Google وغيرها.',
        inventionTitle: 'كيف تم اختراع رمز QR:',
        inventionText: 'تم اختراع رمز QR عام 1994. كان ماساهيرو هارا وفريقه يعملون في شركة يابانية تُدعى Denso Wave تصنع قطع غيار لسيارات Toyota. أرادوا رمزًا يخزّن معلومات أكثر بكثير من الباركود التقليدي، فابتكروا رمز QR.',
        keyFeaturesTitle: 'الميزات الأساسية لرمز QR',
        keyFeatures: [
          {
            title: 'كيف يعمل QR',
            text: 'تُدخل النص أو الرابط لإنشاء رمز QR له. يقوم المولّد بإنشاء مربعات وفقًا للمعلومات. كل مربع يمثل بِتًا، وكل بِت يخزّن حرفًا.',
          },
          {
            title: 'بنية رمز QR',
            text: 'يحتوي رمز QR على ثلاثة مربعات كبيرة لتحديد اتجاه الرمز، إضافةً إلى وحدات مربعة صغيرة لتخزين البِتّات (المعلومات).',
          },
          {
            title: 'سعة بيانات رمز QR',
            text: 'عادةً ما يخزن رمز QR معلومات أكثر من الباركود. ويمكن اعتباره نسخة متقدمة من الباركود لأنه باركود ثنائي الأبعاد. غالبًا ما يخزن قرابة 200 حرف. ويمكنه تخزين 400 حرف أيضًا، لكن قد يصبح المسح أصعب. أما تخزين أكثر من 400 حرف فقد يؤدي إلى رمز شديد التعقيد يصعب مسحه في معظم الحالات.',
          },
          {
            title: 'اكتشاف الأخطاء في رموز QR',
            text: 'قد يظل رمز QR قابلاً للمسح حتى إذا تعرض جزء من معلوماته للخدش أو تغيّرت بعض البِتّات. يستخدم رمز QR تقنية Reed-Solomon لاكتشاف الأخطاء ثم معالجتها بعد تحديدها.',
          },
        ],
        errorTitle: 'مستويات تصحيح الأخطاء في رمز QR:',
        errorIntro: 'تُستخدم تقنيات مختلفة لاكتشاف الأخطاء وتصحيحها حسب الحالة كما يلي:',
        errorHeaders: {
          level: 'المستوى',
          recovery: 'قدرة الاستعادة',
          bestUse: 'أفضل حالة استخدام',
        },
        errorRows: [
          {
            level: 'منخفض (L)',
            recovery: '~7%',
            useCases: [
              'تُستخدم هذه التقنية عندما يُعرض رمز QR على الشاشات الرقمية أو المواقع الإلكترونية أو في بيئة نظيفة.',
              'تُستخدم أيضًا عند إنشاء رمز QR لمعلومات صغيرة مثل Gmail أو رقم اتصال أو نص قصير.',
            ],
          },
          {
            level: 'متوسط (M)',
            recovery: '~15%',
            useCases: [
              'مناسب للمنشورات والملصقات الموضوعة في بيئة نظيفة عندما يكون خطر التلف ضئيلًا.',
            ],
          },
          {
            level: 'ربعي (Q)',
            recovery: '~25%',
            useCases: [
              'يُستخدم عند وضع رمز QR في بيئات قاسية مثل المصانع أو الأماكن الخارجية.',
              'ويُستخدم أيضًا عندما يلزم وضع شعار صغير في الوسط لأنه يغطي بعض البِتّات، لذا نحتاج لهذا المستوى من التصحيح.',
            ],
          },
          {
            level: 'عالٍ (H)',
            recovery: '~30%',
            useCases: [
              'يُستخدم عندما يكون احتمال تعرض رمز QR لتلف كبير مرتفعًا.',
              'عند تغطية مركز رمز QR بشعارات كبيرة.',
              'وأيضًا عند الحاجة إلى تصميم مرئي كثيف لرمز QR.',
            ],
          },
        ],
      },
      card2: {
        title: '2. لماذا تختار مولّد رمز QR الخاص بنا؟',
        intro: 'يُسهّل مولّد رمز QR لدينا إنشاء الرموز بسرعة فائقة وبأمان وبخطوات بسيطة. يمكنك تخصيص رمزك ليصبح أكثر احترافية وتوافقًا مع هوية نشاطك. جميع خيارات التخصيص، من ألوان الرمز حتى إضافة الشعار داخله، متاحة مجانًا دائمًا.',
        strengths: [
          {
            title: 'تخصيص احترافي:',
            text: 'يمكنك إنشاء وتخصيص عدد غير محدود من رموز QR دون أي تكلفة. جميع الميزات مجانية بالكامل. يمكنك استخدام تدرجات لونية وأشكال مختلفة للوحدات المربعة وشعارات مخصصة وميزات أخرى كثيرة.',
          },
          {
            title: 'دعم صيغ متعددة:',
            text: 'يوفر مولّد رمز QR لدينا عدة صيغ تنزيل لراحتك. ما عليك سوى اختيار الصيغة المفضلة قبل التنزيل. حاليًا نوفر الصيغ التالية:',
          },
          {
            title: 'قوالب جاهزة:',
            text: 'يمكنك استخدام تدرجات لونية وإطارات جاهزة تمنح رمز QR مظهرًا احترافيًا.',
          },
          {
            title: 'دعم الشعار المخصص:',
            text: 'يمكنك رفع شعار علامتك التجارية ليتم ضبطه تلقائيًا في منتصف رمز QR. كما يمكنك اختيار شعار من مكتبة الشعارات المدمجة التي تحتوي على أكثر من 30 شعارًا.',
          },
          {
            title: 'معاينة مباشرة:',
            text: 'أثناء التخصيص يمكنك مشاهدة جميع التغييرات في لوحة معاينة مباشرة. كل التحديثات تظهر لحظيًا وبشكل ديناميكي.',
          },
          {
            title: 'مؤشر قابلية المسح:',
            text: 'أثناء اختيار الألوان ستظهر تنبيهات ومؤشرات مناسبة لإرشادك إذا اخترت ألوانًا يصعب مسحها.',
          },
        ],
        formatHeaders: {
          srNo: 'م',
          formats: 'الصيغ',
          description: 'الوصف',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'بدون فقدان، يدعم الشفافية' },
          { no: '2', format: 'JPG', description: 'صيغة ملفات شائعة وعالمية' },
          { no: '3', format: 'WEBP', description: 'صيغة حديثة بأفضل جودة مقابل الحجم' },
          { no: '4', format: 'SVG', description: 'رسوم متجهية قابلة للتحجيم' },
          { no: '5', format: 'PDF', description: 'مستند جاهز للطباعة' },
        ],
      },
      card3: {
        title: '3. دليل خطوة بخطوة:',
        step1Intro: 'أولًا، اختر فئة رمز QR التي تريد إنشاءها، سواء للاتصال أو الخريطة أو الرابط أو النص. حاليًا، يوفّر مولّد رمز QR لدينا هذه الفئات:',
        categories: ['رابط / URL', 'نص', 'WiFi', 'جهة اتصال', 'Gmail', 'Google Maps'],
        step2: 'بعد اختيار الفئة، الصق معلوماتك في مربع النص المناسب.',
        step3Intro: 'ثم انقر على Generate & Customize لفتح لوحة التخصيص. داخل لوحة التخصيص ستجد شريط تنقّل فرعيًا يتضمن الخيارات التالية:',
        options: [
          {
            title: 'النمط والشكل:',
            text: 'في هذا القسم يمكنك تغيير أشكال الوحدات المربعة إلى أنماط متعددة مثل الزوايا الدائرية والنقاط والأشرطة الأفقية والأشرطة العمودية والمربعات الصغيرة وغيرها.',
          },
          {
            title: 'اللون:',
            text: 'يمكنك في هذا القسم اختيار ألوان الخلفية والألوان الأمامية المخصصة. ولجعل رمز QR بتدرجات لونية، يمكنك تفعيل التدرج لتطبيق أي تدرج من المكتبة المدمجة أو إنشاء تدرجك الخاص بسهولة. كما يمكنك تغيير زاوية التدرج الخطي. ويدعم أيضًا التدرج الشعاعي. ويمكنك إضافة عدة ألوان للحصول على تأثير تدرج احترافي.',
          },
          {
            title: 'الإطارات:',
            text: 'هنا يمكنك اختيار إطار مناسب لرمز QR الخاص بك. جميع الإطارات تُضبط تلقائيًا لتناسب الرمز. ما عليك سوى اختيار إطار من المكتبة المدمجة.',
          },
          {
            title: 'الشعار:',
            text: 'بعد اختيار الإطار، يمكنك اختيار شعار يتم ضبطه تلقائيًا في منتصف رمز QR. كما يدعم النظام رفع شعار علامتك التجارية المخصص.',
          },
          {
            title: 'القوالب:',
            text: 'إذا كنت لا تريد اختيار النمط والشكل واللون والإطار بشكل منفصل، يمكنك تطبيق القوالب الجاهزة على رمز QR. تتوفر عدة قوالب مميزة لراحتك وهي مجانية دائمًا.',
          },
          {
            title: 'تنسيق الملف:',
            text: 'أخيرًا، اختر نوع الملف الذي تريد تنزيل رمز QR به. يتم دعم عدة صيغ شائعة بما في ذلك PNG وWEBP وSVG وPDF وغيرها.',
          },
          {
            title: 'تعديل بيانات QR:',
            text: 'يمكنك أيضًا تعديل بيانات QR دون فقدان أي من إعدادات التخصيص التي اخترتها.',
          },
        ],
        finalStep: 'بعد ذلك، انقر فقط على زر التنزيل، وسيتم تنزيل رمز QR فورًا وفقًا لتخصيصاتك تمامًا وبالصيغة التي اخترتها، وبدون أي تكلفة.',
      },
      card4: {
        title: '4. الفوائد:',
        intro: 'يربط رمز QR العالم المادي بالتجربة الرقمية. وهو أسرع طريقة لمشاركة الروابط أو معلومات الاتصال أو موقعك. يكفي فقط مسح رمز QR للوصول إلى المعلومات فورًا. لذلك فهو شائع جدًا في الأعمال والعالم الرقمي لأنه موفّر للوقت وذو فاعلية عالية.',
        benefits: [
          {
            title: 'دعم مدى الحياة:',
            text: 'تعمل رموز QR دائمًا دون تاريخ انتهاء. فهي تُظهر لك المعلومات المخزنة فور مسحها. وبما أنها تخزن تعليمات رقمية مضمّنة بشكل ثابت، فهي لا تفقد معلوماتها.',
          },
          {
            title: 'دعم دون اتصال:',
            text: 'يمكنك مسح رمز QR حتى عند عدم الاتصال بالإنترنت. تقوم كاميرا هاتفك بفك نمط الرمز وتعرض لك المعلومات المخزنة بداخله.',
          },
          {
            title: 'بدون تكلفة:',
            text: 'وبما أن هذه الرموز لا تتطلب إعادة توجيه عبر خادم أو موارد إضافية، فهي مجانية دائمًا.',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'ماسح رمز QR — مسح رموز QR من الكاميرا أو الصورة | photremium.com',
      desc: 'امسح رموز QR فوراً باستخدام كاميرتك أو برفع صورة. سريع وخاص وآمن.',
      keywords: 'ماسح رمز qr، مسح رمز qr، قارئ رمز qr',
    },
    title: 'ماسح رمز QR',
    desc: 'امسح رموز QR فوراً باستخدام كاميرتك أو ارفع صورة. سريع وخاص وآمن.',
    generateQrCode: 'إنشاء رمز QR',
    scan: 'مسح',
    cameraScanner: 'ماسح الكاميرا',
    uploadImage: 'رفع صورة',
    pointCamera: 'وجّه كاميرتك نحو رمز QR',
    startCamera: 'تشغيل الكاميرا',
    loading: 'جارٍ التحميل…',
    dropQrImage: 'أسقط صورة رمز QR هنا',
    toScan: 'للمسح',
    supportedFormats: 'يدعم JPG وPNG وGIF وWEBP',
    ctrlVPaste: 'Ctrl+V للصق',
    scanFromGallery: 'المسح من المعرض',
    instantScanning: 'مسح فوري',
    instantScanningDesc: 'كشف رمز QR في الوقت الفعلي من الكاميرا أو الصور المرفوعة',
    private100: '100% خاص',
    private100Desc: 'تتم جميع العمليات في متصفحك. لا يُرفع شيء',
    multiFormat: 'متعدد التنسيقات',
    multiFormatDesc: 'كشف الروابط والنصوص وWiFi وجهات الاتصال والبريد الإلكتروني والهاتف والمزيد',
    accessingCamera: 'جارٍ الوصول إلى الكاميرا…',
    cameraDenied: 'تم رفض الوصول للكاميرا. يرجى السماح بإذن الكاميرا والمحاولة مجدداً.',
    noCamera: 'لم يتم العثور على كاميرا في هذا الجهاز.',
    cameraError: 'تعذّر الوصول إلى الكاميرا. حاول مجدداً.',
    videoError: 'تعذّر بدء تشغيل الفيديو.',
    switchError: 'تعذّر تبديل الكاميرا.',
    tryAgain: 'حاول مجدداً',
    switchCamera: 'تبديل الكاميرا',
    stop: 'إيقاف',
    noQrFound: 'لم يُعثر على رمز QR',
    couldNotRead: 'تعذّر قراءة الصورة',
    scannerFailed: 'فشل تحميل الماسح',
    noQrFoundDesc: 'لم يُكتشف رمز QR في الصورة. جرّب صورة أخرى أو استخدم ماسح الكاميرا.',
    qrScanned: 'تم مسح رمز QR!',
    openLink: 'فتح الرابط',
    copied: 'تم النسخ!',
    copy: 'نسخ',
    share: 'مشاركة',
    scanAgain: 'مسح مجدداً',
    network: 'الشبكة',
    password: 'كلمة المرور',
    security: 'الأمان',
    unknown: 'غير معروف',
    typeText: 'نص',
    typeUrl: 'URL',
    typeWifi: 'شبكة WiFi',
    typeContact: 'بطاقة اتصال',
    typeEmail: 'بريد إلكتروني',
    typePhone: 'رقم هاتف',
    typeSms: 'SMS',
    typeLocation: 'موقع',
    blog: {
      tocTitle: 'المحتويات',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. لماذا نستخدم ماسح رمز QR؟',
          paragraphs: [
            'ماسح رمز QR هو في الأساس كاميرا هاتف تقوم بفك ترميز المعلومات المخزنة داخل رمز QR. كل ما عليك هو توجيه الكاميرا نحو رمز QR، وبغض النظر عن اتجاهه سيقرأ الأنماط الخاصة، ويكتشف الأخطاء، ويصححها عند الحاجة، ثم يعرض المعلومات الموجودة بداخله.',
          ],
          listTitle: 'أنواع ماسحات رمز QR:',
          bullets: [
            'ماسح رمز QR عبر الويب: يمكنك مسح رموز QR باستخدام ماسحات أونلاين يدعمها متصفحك. يمكنك الوصول للمعلومات عبر الكاميرا أو عبر رفع صورة الرمز. ولإعادة التوجيه التلقائي والمزايا المتقدمة الأخرى يمكنك زيارة https://photremium.com.',
            'كاميرات الهاتف: بعض الهواتف الحديثة تحتوي على ماسح QR مدمج داخل تطبيق الكاميرا الأصلي. يمكنه جلب المعلومات وفك ترميزها بمجرد توجيه الكاميرا إلى الرمز.',
            'التطبيقات: توجد تطبيقات مخصصة لمسح رموز QR. ولكن لإعادة التوجيه المتقدمة والعديد من الميزات الأخرى، يمكنك تثبيت التطبيق عبر هذا الرابط مجانًا: https://photremium.com.',
            'أجهزة مادية: توجد أيضًا أجهزة مادية مخصصة لمسح رموز QR. تُستخدم هذه الأجهزة بكثرة في المراكز التجارية الكبيرة لفوترة المنتجات.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. لماذا تختار ماسح رمز QR الخاص بنا؟',
          paragraphs: [
            'يمكنك الاستفادة من عدة ميزات متقدمة، من إعادة التوجيه إلى نسخ المحتوى المفكوك من رمز QR. كما يمكنك اكتشاف العديد من الميزات الممتعة الأخرى في ماسح رمز QR لدينا مثل:',
          ],
          bullets: [
            'سرعة عالية: ماسح QR الخاص بنا يجعل فك ترميز الرمز سريعًا جدًا. كل ما عليك هو مسح رمز QR، وستظهر لك المعلومات فورًا مع خيارات متقدمة لنسخ النص/الرابط، أو فتحه إذا تم اكتشاف رابط، أو الحفظ التلقائي إذا تم اكتشاف جهة اتصال.',
            'بدون تثبيت: لا تحتاج إلى تثبيت أي تطبيق منفصل لاستخدام ماسح رمز QR لدينا. يمكنك استخدام هذه الأداة عبر متصفحك المحلي مجانًا.',
            'وصول متعدد المنصات: يمكنك استخدامه على أي جهاز. لا داعي للقلق بشأن إصدار نظام التشغيل أو أي متطلبات أخرى. الأداة مدعومة على جميع الإصدارات وجميع الأجهزة.',
            'دعم جميع الصيغ: جميع صيغ البيانات التي يمكن تخزينها داخل رمز QR مدعومة لدينا، بما فيها النصوص العادية وWiFi والروابط وجهات الاتصال وGmail وخرائط Google وغيرها.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. دليل خطوة بخطوة:',
          steps: [
            {
              heading: '1. أولاً، اختر طريقة لمسح رمز QR. توجد طريقتان للقيام بذلك:',
              subSteps: [
                {
                  heading: 'i. طريقة الكاميرا',
                  paragraphs: [
                    'يمكنك مسح رمز QR باستخدام كاميرا جهازك حتى لو كنت تستخدم لابتوب أو كمبيوتر مكتبي أو أي جهاز يدعم كاميرا بسيطة. بمجرد الضغط على زر “بدء الكاميرا” ستظهر نافذة طلب إذن، قم بالسماح لهذا الموقع باستخدام الكاميرا لمسح QR. إذا رفضت الإذن بالخطأ أو لم يظهر الطلب، يمكنك منح صلاحية الكاميرا يدويًا باتباع الخطوات التالية:',
                  ],
                  notes: [
                    '➔ لمتصفح Chrome (Android / Desktop):',
                    '1. اضغط على النقاط الثلاث',
                    '2. اذهب إلى الإعدادات',
                    '3. (تجاوز هذه الخطوة في Android) الخصوصية والأمان',
                    '4. اضغط على إعدادات الموقع',
                    '5. ثم في قسم الأذونات اضغط على الكاميرا',
                    '6. ابحث عن رابط موقعنا: https://photremium.com/qr-code-scanner',
                    '7. فعِّل السماح بالكاميرا من القائمة المنسدلة.',
                    '➔ لمتصفح Safari (iPhone / iOS):',
                    '1. اضغط على أيقونة AA أو إعدادات الموقع في شريط العنوان.',
                    '2. اختر Website Settings.',
                    '3. اضغط على Camera ثم اختر Allow.',
                    '4. إذا ظلّ الحظر موجودًا: اذهب إلى إعدادات iPhone > Safari > Camera واضبطها على Ask أو Allow.',
                  ],
                },
                {
                  heading: 'ii. طريقة المعرض',
                  paragraphs: [
                    'يمكنك رفع صورة رمز QR للوصول إلى المعلومات الموجودة بداخله. اضغط على زر “المسح من المعرض”، وسيُفتح مستعرض الملفات. بعد ذلك اختر صورة رمز QR. جميع صيغ الصور مدعومة مثل .jpg و.jpeg و.png و.gif و.webp و.svg و.avif و.heic و.heif و.jxl و.bmp و.ico و.tiff و.tif و.jfif و.jpe و.pjpeg و.pjp و.apng و.svgz و.xbm وغيرها.',
                  ],
                },
              ],
            },
            {
              heading: '2. عند اختيار رمز QR، ستظهر جميع المعلومات؛ مما يتيح لك النسخ أو المشاركة أو فتح الرابط إذا تم اكتشافه. ويمكنك أيضًا إعادة المسح إذا أردت.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'فوائد ماسح رمز QR:.',
          paragraphs: [
            'يوفر ماسح رمز QR عدة فوائد في هذا العالم الرقمي. فهو يجعل الدفع والتحقق والوصول إلى المعلومات أسهل وأسرع حتى في وضع عدم الاتصال.',
          ],
          bullets: [
            'وصول فوري إلى المعلومات: مسح رمز QR يوفّر المعلومات خلال أجزاء من الثانية. يفك الأنماط ويكتشف الأخطاء ويعالجها بسرعة كبيرة، مما يمنح المستخدم تجربة فائقة السرعة.',
            'اتصال سلس: في هذا العصر المتقدم، هناك حاجة ملحّة إلى تواصل سريع وآمن للمعلومات الصغيرة مثل البيانات البنكية وتفاصيل المنتجات وغيرها. يساعد ماسح QR في حل ذلك لأن المدفوعات تتم عبر مسح رمز QR. كما تستخدم Google التحقق عبر QR للهاتف عند إنشاء حساب جديد على اللابتوب.',
            'التذاكر الإلكترونية: في محطات الحافلات والقطارات والمطارات، يمكنك التحقق من التذاكر بسهولة دون انتظار طويل في الطوابير. إضافةً إلى ذلك، يتم تثبيت ماسحات QR في عدة مواقع داخل المطارات لتقليل الازدحام، مما يقلل الحاجة للموظفين ويوفر ميزانية شركات الطيران.',
            'توثيق المنتجات: تقوم العلامات التجارية المتقدمة بوضع رمز QR على منتجاتها. يمكن للعميل مسح هذا الرمز للتحقق من أصالة المنتج وهل هو أصلي أم لا.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'أداة تمويه الوجه — تمويه الوجوه في الصور | photremium.com',
      uploadDesc: 'موّه الوجوه في صورك تلقائياً باستخدام الذكاء الاصطناعي. مجاناً وسريع وخاص.',
      uploadKeywords: 'تمويه الوجه، تمويه الوجوه، كشف الوجه',
      workspaceTitle: 'أداة تمويه الوجه — photremium.com',
      workspaceDesc: 'تمويه الوجوه في صورك تلقائياً. 100% مجاناً وسريع وخاص.',
      workspaceKeywords: 'تمويه الوجه',
    },
    title: 'تمويه الوجه',
    desc: 'كشف وتمويه الوجوه تلقائياً في صورك للخصوصية.',
    toBlurFaces: 'لتمويه الوجوه',
    autoDetection: 'الكشف التلقائي',
    autoDetectionDesc: 'كشف الوجهة بالذكاء الاصطناعي يجد جميع الوجوه فوراً',
    customBlur: 'تمويه مخصص',
    customBlurDesc: 'اضبط شدة التمويه وشكله ونمطه',
    private100: '100% خاص',
    private100Desc: 'تتم جميع العمليات محلياً في متصفحك',
    blurTools: 'أدوات التمويه',
    faces: 'الوجوه',
    faceDetection: 'كشف الوجه',
    detecting: 'جارٍ الكشف...',
    autoDetectFaces: 'كشف الوجوه تلقائياً',
    exitManualMode: 'الخروج من الوضع اليدوي',
    manualSelect: 'تحديد يدوي',
    nFaceRegions: 'تم العثور على {n} منطقة وجه',
    noFacesDetected: 'لم يُكتشف أي وجه — استخدم الوضع اليدوي',
    manualHint: 'انقر واسحب على الصورة لرسم مستطيل على المنطقة التي تريد تمويهها.',
    blurType: 'نوع التمويه',
    blur: 'تمويه',
    emoji: 'إيموجي',
    blurIntensity: 'شدة التمويه',
    strength: 'القوة',
    blurShape: 'شكل التمويه',
    rectangle: 'مستطيل',
    ellipse: 'دائرة',
    circle: 'دائرة',
    chooseEmoji: 'اختر إيموجي',
    blurRegionsN: 'مناطق التمويه ({n})',
    faceN: 'الوجه {n}',
    manualRegionN: 'المنطقة اليدوية {n}',
    manualN: 'يدوي {n}',
    clearAllRegions: 'مسح جميع المناطق',
    processingDots: 'جارٍ المعالجة...',
    downloadBlurred: 'تحميل الصورة الممواهة',
    downloadNImages: 'تحميل {n} صور',
    downloadDialogTitle: 'لم تُحرَّر جميع الصور',
    downloadDialogText: 'لقد حررت {edited} من أصل {total} صورة.',
    downloadAll: 'تحميل الكل',
    removeRegion: 'حذف المنطقة',
    region: 'منطقة',
    notAllEdited: 'لم تُحرَّر جميع الصور',
    editedXofY: 'لقد حررت {edited} من أصل {total} صورة.',
    nextImage: 'الصورة التالية',
  },

  faqData: {
    imageConverter: [
      { q: 'ما صيغ الصور المدعومة للتحويل؟', a: 'ندعم JPG و PNG و WEBP و SVG و GIF و BMP و ICO و TIFF. يمكنك التحويل بين هذه الصيغ فوراً في متصفحك.' },
      { q: 'هل ستتأثر جودة الصورة أثناء التحويل؟', a: 'للصيغ عديمة الفقد كـ PNG تُحفظ الجودة كاملاً. لصيغ الضغط كـ JPG و WEBP نستخدم إعدادات ترميز محسّنة للحفاظ على أفضل جودة بصرية.' },
      { q: 'هل توجد حدود لحجم الملف أو الكمية؟', a: 'لا يوجد حد صارم. يمكنك رفع صور متعددة دفعة واحدة وتحويلها جماعياً. كل شيء يعمل محلياً في متصفحك.' },
      { q: 'هل بياناتي آمنة؟ هل تُرفع الصور إلى خادم؟', a: 'تماماً. تتم جميع المعالجة بنسبة 100% في متصفحك. لا تغادر صورك جهازك قط.' },
      { q: 'هل يمكنني تحويل صور PNG الشفافة إلى JPG؟', a: 'نعم. بما أن JPG لا يدعم الشفافية، ستُملأ المناطق الشفافة بخلفية بيضاء افتراضياً.' },
    ],
    imageCompressor: [
      { q: 'هل سيؤدي ضغط الصورة إلى تقليل جودتها؟', a: 'لا، ضغط الصورة لا يؤثر على الجودة إلا إذا تجاوزت حدود الضغط الموصى بها. المؤشرات تساعدك على اختيار الجودة المناسبة: i. من 1% إلى 40%: يظهر مؤشر أخضر مع رسالة «جودة جيدة». ii. من 41% إلى 60%: يظهر مؤشر أصفر مع رسالة «جودة عادية»، وهذا النطاق موصى به غالبًا. iii. من 61% إلى 100%: يظهر تحذير أحمر مع رسالة «جودة منخفضة»، وقد يصبح فرق الجودة واضحًا للعين.' },
      { q: 'ما صيغ الصور المدعومة للضغط؟', a: 'أداة ضغط الصور لدينا تدعم جميع الصيغ التالية:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'هل يمكنني ضغط عدة صور دفعة واحدة؟', a: 'نعم بالتأكيد. يمكنك ضغط عدة صور معًا (حتى أكثر من 100 صورة) إذا كان جهازك يتحمل ذلك. بما أن الضغط يتم باستخدام موارد جهازك، فالأجهزة الأقوى تعطي أداءً أفضل. وإذا كان جهازك محدود الإمكانيات، يمكنك الضغط على دفعات بسهولة لأن الأداة مجانية بالكامل.' },
      { q: 'هل تقومون بتخزين صوري أو رفعها إلى الخادم؟', a: 'لا، نحن لا نرفع صورك ولا نخزنها على خوادمنا. جميع الصور تُضغط محليًا داخل متصفحك، وصورك لا تغادر جهازك أبدًا. لذلك يمكنك ضغط الصور الشخصية أو الخاصة بأمان وخصوصية.' },
      { q: 'هل أداة ضغط الصور هذه مجانية؟', a: 'نعم، أداة ضغط الصور لدينا مجانية تمامًا وللأبد. لن نطلب منك أي دفع، ولا توجد رسوم مخفية. جميع الميزات بما فيها ضغط عدة صور متاحة مجانًا.' },
    ],
    cropImage: [
      { q: 'هل سيؤدي قص الصورة إلى تقليل جودتها؟', a: 'لا، قص الصورة لن يؤثر على الجودة البصرية للصورة على الإطلاق. قص الصورة يزيل فقط الأجزاء غير المرغوب فيها. ولا يغيّر أبدًا بكسلات الجزء المراد قصه من الصورة. لذلك يمكنك قص صورك بجودتها الأصلية دون أي تلف في البكسلات.' },
      { q: 'ما صيغ الصور المدعومة لأداة قص الصور؟', a: 'يمكنك اختيار أي صورة بأي صيغة لأن أداة قص الصور الخاصة بنا توفر تقريبًا جميع صيغ الصور. وهي مدرجة أدناه:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'هل تُرفع صوري إلى خادمكم؟', a: 'لا، ستتم كل المعالجة على متصفحك المحلي. لن يتم رفع صورك إلى خادمنا أبدًا لأنها لا تغادر جهازك مطلقًا. لذلك يمكنك قص صورك الشخصية باستخدام أداة قص الصور الخاصة بنا دون أي مخاطر.' },
      { q: 'هل يمكنني قص عدة صور دفعة واحدة؟', a: 'نعم، يمكنك قص عدة صور (حتى أكثر من 100 صورة) دفعة واحدة إذا كان نظامك يدعم ذلك. وبما أن قص الصور يستخدم موارد نظامك، فإذا كان لديك لابتوب أو كمبيوتر أو هاتف عالي الأداء، يمكنك قص عدد كبير من الصور دفعة واحدة. وإذا كان جهازك من الفئة الضعيفة، يمكنك قص الصور على دفعات لأن هذه الأداة مجانية حتى عند قص عدة صور دفعة واحدة.' },
      { q: 'هل أداة قص الصور هذه مجانية الاستخدام؟', a: 'نعم، أداة قص الصور هذه مجانية تمامًا للأبد. يمكنك الوصول إلى هذه الأداة في أي مكان وفي أي وقت وباستخدام أي جهاز. ولن تحصل فقط على تصميم متجاوب لجميع الأجهزة، بل لن يُطلب منك أبدًا الدفع مقابل أي ميزة مدفوعة. جميع الميزات مجانية تمامًا بدون أي رسوم خفية.' },
    ],
    resizeImage: [
      { q: 'هل يمكنني تغيير حجم عدة صور في وقت واحد؟', a: 'بالتأكيد، تتيح لك أداة تغيير حجم الصور لدينا تغيير حجم عدة صور دفعة واحدة. فقط ارفع عدد الصور الذي يدعمه جهازك، وسيقوم محركنا المدعوم بالذكاء الاصطناعي بتغيير حجم جميع صورك مرة واحدة. إذا كان جهازك منخفض الإمكانيات، جرّب تغيير الحجم على دفعات متعددة لتجنّب أي بطء. تغيير الحجم يستهلك موارد الجهاز لأنه يتم محليًا دون رفع الصور إلى أي خادم حفاظًا على خصوصيتك.' },
      { q: 'هل أداة تغيير حجم الصور هذه مجانية الاستخدام؟', a: 'نعم، هذه الأداة مجانية للاستخدام مدى الحياة. لن يُطلب منك أبدًا أي اشتراك مدفوع لفتح ميزات إضافية. لا توجد أي رسوم مخفية عند تنزيل الصور بعد تغيير حجمها.' },
      { q: 'هل سيؤدي تغيير حجم الصورة إلى تقليل جودتها؟', a: '✅تصغير الحجم (downscale): تقليل حجم الصورة لن يقلل الجودة البصرية للصورة أبدًا. بل قد تبدو الصورة بعد التصغير أكثر حدة من الأصل. لذلك، تغيير الصورة إلى أبعاد أصغر من الأصل لن يقلل جودتها.\n❌تكبير الحجم (upscale): زيادة الحجم فوق الحجم الأصلي قد تؤثر على الجودة البصرية للصورة. درجة التأثر تعتمد على مقدار الزيادة في الحجم. وكلما زادت الزيادة، زاد انخفاض الجودة.' },
      { q: 'هل أداة تغيير حجم الصور هذه آمنة للاستخدام؟', a: 'نعم، أداة تغيير حجم الصور لدينا آمنة تمامًا، خصوصًا لصورك الشخصية والخاصة، لأن جميع الصور تُعالج محليًا. لا يغادر أي جزء من بياناتك جهازك بأي شكل أثناء المعالجة. لذلك يمكنك تغيير حجم صورك الشخصية دون أي مخاطر.' },
      { q: 'ما صيغ الصور المدعومة؟', a: 'جميع صيغ الصور مدعومة في أداة تغيير حجم الصور لدينا. يمكنك اختيار الصور بهذه الصيغ:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'كيف تعمل إزالة الخلفية؟', a: 'نستخدم نموذج ذكاء اصطناعي متقدم يعمل مباشرة في متصفحك للكشف عن الموضوع وفصله عن الخلفية.' },
      { q: 'هل تعمل مع الخلفيات المعقدة؟', a: 'نعم. يتعامل النموذج مع مجموعة متنوعة واسعة من المشاهد. أفضل النتائج مع تباين واضح بين الموضوع والخلفية.' },
      { q: 'هل يمكنني إزالة الخلفية من صور متعددة دفعة واحدة؟', a: 'نعم. ارفع صوراً متعددة وستعالجها الأداة بالتسلسل. نزّل جميع النتائج كـ ZIP.' },
      { q: 'ما صيغة الإخراج؟', a: 'الإخراج دائماً ملف PNG بخلفية شفافة.' },
      { q: 'هل تُرسل صوري إلى خادم؟', a: 'لا. يعمل نموذج الذكاء الاصطناعي كلياً في متصفحك باستخدام WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. هل أداة العلامة المائية في Photremium مجانية بالكامل للاستخدام؟', a: 'نعم، أداة العلامة المائية على photremium.com/watermark-image مجانية للاستخدام دون حساب وبدون اشتراك. يمكنك وضع علامة مائية على صورة واحدة أو على دفعات كاملة دون أي جدار دفع، وبدون مطالبات تسجيل، وبدون حدود للتحميل. تمويل الأداة قائم على تقديم قيمة حقيقية ضمن منصة Photremium — وليس على إغلاق الميزات الأساسية خلف الاشتراكات.' },
      { q: '2. كم عدد الصور التي يمكنني وضع علامة مائية عليها دفعة واحدة؟', a: 'تدعم الأداة وضع علامة مائية على عدة صور في وقت واحد. يمكنك سحب وإفلات مجلد كامل من الصور في منطقة الرفع، أو استخدام Ctrl+Click في محدد الملفات لاختيار عشرات الملفات دفعة واحدة. يظهر شريط المصغرات في اليسار كل الصور، وعند الضغط على "Watermark & Download All" تقوم الأداة برسم العلامة المائية على كل صورة ثم تحزمها في ملف ZIP واحد (أو تنزيلها كملفات منفصلة — حسب اختيارك). عملياً، الحد هو ذاكرة جهازك المتاحة، وليس أي حد مصطنع من الأداة.' },
      { q: '3. ما صيغ الصور المدعومة للإدخال والإخراج؟', a: 'المدخل يقبل أي صيغة صور يمكن لمتصفحك التعامل معها عبر File API، وغالباً يشمل JPEG وJPG وPNG وWEBP وGIF (غير متحرك) وBMP وSVG. في الإخراج، تُحفظ الصيغة كما هي: إذا رفعت PNG ستستلم PNG، وإذا رفعت JPEG ستستلم JPEG بجودة 0.95. هذا يحميك من تحويل PNG بلا فقد إلى JPG بفقدان غير مقصود.' },
      { q: '4. هل ستبدو العلامة المائية نفسها على الصور ذات الدقات المختلفة؟', a: 'نعم، بفضل محرك التموضع النسبي في الأداة. عندما تعمل على مجموعة صور بأبعاد مختلفة، يتم تصميم العلامة على الصورة المرجعية (التي تعمل عليها في القماش). عند التصدير، يحسب المحرك مركز كتلة كل طبقة كنسبة من مركز الصورة المرجعية، ثم يطبق نفس النسبة على كل صورة مستهدفة. كما يتم تحجيم حجم العلامة بشكل نسبي باستخدام أصغر نسبة مقياس (بين نسبة العرض ونسبة الارتفاع) لضمان عدم تجاوز حدود الصورة. النتيجة هي علامة مائية تحافظ على نفس الموضع النسبي والحجم عبر الدفعة بالكامل حتى مع اختلاف الدقة.' },
      { q: '5. هل يمكنني استخدام شعاري أو توقيعي كعلامة مائية بدلاً من النص؟', a: 'بالتأكيد. زر "Add Image" في اللوحة اليمنى يسمح لك برفع أي ملف صورة من جهازك كطبقة علامة مائية. تعمل ملفات PNG ذات الخلفية الشفافة بشكل مثالي — تُحفظ الشفافية بحيث يظهر الشعار فقط دون أي مربع خلفه. يمكنك تغيير حجم الشعار بسحب مقابض الزوايا (مع الحفاظ على النسبة)، وتدويره، وعكسه، وضبط الشفافية، بل وإضافة إطار أو تدوير زوايا. كثير من المستخدمين يحتفظون بنسخة شعار شفافة جاهزة خصيصاً للاستخدام كعلامة مائية.' },
      { q: '6. كيف أجعل العلامة المائية شفافة أو شبه شفافة؟', a: 'حدد طبقة العلامة المائية بالنقر عليها داخل القماش. في شريط الأدوات العلوي سيظهر تحكم الشفافية كنسبة مئوية، ويمكنك كتابة الرقم أو تحريكه. لعلامة مائية احترافية وغير مزعجة، غالباً تكون 30–50% هي الأنسب. لعلامة أكثر وضوحاً يصعب تجاهلها، تكون 70–80% مناسبة. ويمكنك مقارنة النتيجة سريعاً بتفعيل/إخفاء الطبقة من مدير الطبقات (أيقونة العين).' },
      { q: '7. هل يمكنني إضافة عدة علامات مائية على صورة واحدة؟', a: 'نعم — نظام الطبقات يدعم عدداً غير محدود من طبقات العلامة المائية، وكل طبقة لها إعداداتها الخاصة. يمكنك وضع نص حقوق في الزاوية اليمنى السفلية، وشعار في الزاوية العليا، وطبقة "SAMPLE" مبلطة في نفس الوقت. لكل طبقة شفافية ودوران وموضع وحجم ونمط مستقل. مدير الطبقات في اللوحة اليمنى ينظمها، ويمكنك إخفاء أي طبقة أو إظهارها دون حذفها لتجربة أكثر من نسخة.' },
      { q: '8. ما الذي تفعله ميزة التبليط ومتى أستخدمها؟', a: 'ميزة التبليط تكرر العلامة المائية ضمن شبكة تغطي الصورة بالكامل. خيار Grid 2×2 يضع أربع نسخ، وخيار Grid 3×3 يضع تسع نسخ. يتيح لك التحكم في التباعد تحديد المسافة بين النسخ. التبليط مفيد عندما تريد جعل الصورة غير قابلة للاستخدام دون إذن — إذ إن علامة واحدة في الزاوية يمكن قصها بسهولة، بينما التبليط يجعل إزالة العلامة صعبة جداً دون إتلاف الصورة. هذه الطريقة شائعة لمشاركة معاينات العقود، أو مسودات الأعمال قبل الدفع، أو أي محتوى لا ينبغي استخدامه قبل الاتفاق.' },
      { q: '9. هل تعمل الأداة على الهواتف والأجهزة اللوحية؟', a: 'نعم، الأداة متجاوبة بالكامل ومصممة للموبايل. على الشاشات الأصغر من 900 بكسل، يتحول التخطيط من ثلاث لوحات إلى تخطيط مكدس: شريط المصغرات يصبح صفاً أفقياً في الأعلى، القماش في المنتصف، ولوحة الإعدادات تصبح ورقة سفلية تُفتح بزر ترس عائم. كل العناصر التفاعلية — السحب، مقابض التحجيم، الدوران — تدعم اللمس. كما أن مقابض التحجيم أكبر قليلاً على الهاتف (16×16 بكسل بدل حجم سطح المكتب) لتسهيل اللمس.' },
      { q: '10. هل بيانات صوري خاصة؟ وهل تُرفع الصور إلى أي خادم؟', a: 'صورك لا تغادر جهازك. كل عملية العلامة المائية — تحميل الصور، رسم الطبقات، تصدير الملف النهائي — تتم داخل المتصفح باستخدام JavaScript وHTML5 Canvas API. عند رفع صورة، تُنشئ File API تمثيلاً داخل الذاكرة. عند إضافة علامة مائية، تُرسم على Canvas مخفية. وعند التحميل، تتحول بيانات البيكسل إلى Blob ويسلمها المتصفح للتنزيل محلياً. لا توجد أي طلبات شبكة تتضمن بيانات صورك. بالإضافة لذلك، تحتوي الأداة على حاجز عند مغادرة الصفحة: إذا حاولت الإغلاق أثناء وجود صور، سيطلب المتصفح تأكيداً لمنع فقدان عملك.' },
    ],
    qrCodeGenerator: [
      { q: 'هل تنتهي صلاحية رمز QR هذا؟', a: 'لا، رموز QR هذه لا تنتهي صلاحيتها وتدعم الاستخدام مدى الحياة. وبما أنها تخزّن تعليمات مُشفّرة بشكل ثابت على هيئة بِتّات داخل مربعات، فلا يمكن تغيير المعلومات المخزنة فيها أو حذفها. يمكنك الوصول إلى المعلومات داخل الرمز بمجرد مسحه بأي كاميرا حتى بعد سنوات.' },
      { q: 'لماذا لا يتم مسح رمز QR الخاص بي؟', a: 'قد يفشل مسح رمز QR للأسباب التالية: i. انخفاض التباين: إذا اخترت لونين متشابهين جداً للخلفية والمقدمة، ستضعف رؤية الرمز وقد يفشل المسح. لكن أداتنا تُرشدك أثناء التخصيص عند وجود تباين منخفض أو أي مشكلة تتعلق بالمسح. ii. كثرة البيانات: إذا أنشأت رمز QR لنص طويل جداً، يصبح الرمز معقداً ويصعب مسحه. يوجد مُتحقق لطول النص يوجّهك للطول الأمثل أثناء الإنشاء. iii. طباعة ضبابية: احرص على تنزيل الرمز بصيغة عالية الدقة مثل PNG أو SVG، وهما مدعومتان بالفعل في أداتنا.' },
      { q: 'هل يمكنني إضافة شعار داخل رمز QR؟', a: 'بالتأكيد، يمكنك إضافة شعار مخصص أو اختيار شعار من مكتبة الشعارات المدمجة لرمزك. وسيتم ضبط الشعار الذي اخترته تلقائياً في منتصف رمز QR.' },
      { q: 'كيف يمكنني مسح رمز QR؟', a: 'يمكنك مسح رمز QR باستخدام كاميرا هاتفك. ولإعادة التوجيه التلقائي إلى الرابط والحصول على مزايا متقدمة إضافية، يمكنك استخدام ماسح QR المجاني لدينا عبر الرابط https://photremium.com/qr-code-scanner.' },
      { q: 'كم عدد رموز QR التي يمكنني إنشاؤها مجاناً؟', a: 'غير محدود! يمكنك إنشاء عدد كبير من رموز QR مجاناً. جميع الميزات والتخصيصات والقوالب مجانية للأبد للجميع، ولا حاجة لأي اشتراك للاستفادة من الميزات المتقدمة.' },
      { q: 'هل أحتاج إلى تسجيل الدخول/إنشاء حساب لإنشاء رمز QR؟', a: 'لا، فقط أدخل النص، أنشئ رمز QR، ثم نزّله بعد التخصيص. لا حاجة لتسجيل الدخول أو إنشاء حساب، فجميع الميزات متاحة مجاناً بالكامل.' },
    ],
    qrCodeScanner: [
      { q: 'هل يمكنني مسح رمز QR من الصور المحفوظة ولقطات الشاشة؟', a: '**نعم**، يمكنك مسح رمز QR من الصور المحفوظة أو لقطات الشاشة. يتيح لك ماسح رمز QR الخاص بنا https://photremium.com/qr-code-scanner مسح رمز QR من المعرض. كل ما عليك هو اختيار الصورة وستحصل على جميع المعلومات المستخرجة من ذلك الرمز.' },
      { q: 'هل أحتاج إلى تثبيت تطبيق لاستخدام ماسح رمز QR؟', a: '**لا**، ماسح رمز QR عبر الويب يتيح لك المسح دون الحاجة إلى تثبيت أي تطبيق. يمكنك الوصول إلى ماسح QR المتقدم لدينا على أي جهاز مجانًا.' },
      { q: 'لماذا لا يتعرف الماسح على رمز QR؟', a: 'قد يفشل مسح رمز QR لديك لأحد الأسباب التالية: i. إضاءة غير كافية: المسح في إضاءة خافتة قد يسبب مشاكل. شغّل الفلاش وارفع السطوع إذا كنت تمسح من شاشة. ii. المسافة: المسح من مسافة غير مناسبة يسبب أيضًا مشاكل. المسافة المثالية للمسح حوالي 10 بوصات (25 سم). iii. اتساخ عدسة الكاميرا: قد يفشل المسح أيضًا بسبب عدسة متسخة. نظّف العدسة قبل المسح. “هل ترى شبكة مربعات في الماسح؟ فقط ضع رمز QR داخلها ليتم مسحه بنجاح.”' },
      { q: 'هل تستطيع هذه الأداة مسح رمز QR مقلوبًا أو ملوّنًا؟', a: '**نعم**، يمكنك مسح رمز QR بأي لون أو اتجاه. ولكن إذا كان التباين بين لون الخلفية ولون المقدمة منخفضًا فقد يسبب ذلك صعوبة في المسح.' },
      { q: 'هل هذه الأداة مجانية؟', a: '**نعم**، هذه الأداة مجانية تمامًا. يمكنك مسح عدد غير محدود من رموز QR مجانًا إلى الأبد.' },
    ],
    faceBlur: [
      { q: 'كيف يعمل اكتشاف الوجه؟', a: 'نستخدم نموذج اكتشاف وجه مدعوماً بالذكاء الاصطناعي يعمل مباشرة في متصفحك لتحديد الوجوه في الصورة.' },
      { q: 'هل يمكنني اختيار الوجوه التي أريد تمويهها؟', a: 'نعم. بعد الاكتشاف، تُبرز كل منطقة وجه ويمكنك اختيار أيها تريد تمويهه وضبط الشدة.' },
      { q: 'ما أنماط التمويه المتوفرة؟', a: 'يمكنك الاختيار بين التمويه الغاوسي أو التبعير أو تغطية اللون الصلب، مع إمكانية ضبط الشدة بالكامل.' },
      { q: 'هل يمكنني تمويه وجوه في صور متعددة دفعة واحدة؟', a: 'نعم. ارفع صوراً متعددة، اضبط مناطق التمويه ونزّل جميع الصور المعالجة.' },
      { q: 'هل تُرسل صوري إلى خادم بعيد؟', a: 'لا. يعمل نموذج الذكاء الاصطناعي في متصفحك باستخدام WebAssembly. لا تُرفع صورك إلى أي خادم.' },
    ],
    photoEditor: [
      { q: 'ما ميزات التحرير المتوفرة؟', a: 'يمكنك ضبط السطوع والتباين والتشبع وتطبيق فلاتر وإضافة نص وتراكبات وإطارات وملصقات والمزيد — كل ذلك في متصفحك.' },
      { q: 'هل يمكنني التراجع عن التغييرات وإعادتها؟', a: 'نعم. يدعم المحرر سجل تراجع/إعادة كامل.' },
      { q: 'ما صيغ الملفات التي يمكنني تحريرها وتصديرها؟', a: 'يمكنك تحرير JPG و PNG و WEBP والصيغ الشائعة الأخرى. يمكن تصدير الصورة المحررة بالصيغة والجودة المفضلة لديك.' },
      { q: 'هل يعمل المحرر على الهاتف؟', a: 'نعم. المحرر متجاوب بالكامل وملائم للمس.' },
      { q: 'هل تُخزَّن صوري على خوادمكم؟', a: 'لا. يتم كل التحرير محلياً. لا تغادر صورك جهازك أبداً.' },
    ],
  },
};

export default ar;